import invert from 'lodash/invert';
import {
    EnumDisplayType, EnumEventDateFilterType, EnumHandicapType, EnumLanguageType, EnumMarkedTokenVersion, EnumMarketType, EnumOddsStyle, EnumPresetFilterType, EnumPriceStyle, EnumSelectionStatus, EnumSportType, EnumTokenVersion, EnumTournamentSizeType,
    EnumTournamentStage,
    TiEnumEventStatus,
} from '@/core/oddsApi/oddsApiType';
import {
    CompositeMarketStatus,
    DisplayOddStyle,
    EnumResultFGLG,
    EnumScoringType,
    EnumSportsBannerAction,
    BannerPosition as PolluxBannerPosition,
    BehaviorType as PolluxBehaviorType,
    BrandType as PolluxBrandType,
    CashOutStatus as PolluxCashOutStatus,
    ContestStatus as PolluxContestStatus,
    DisplayTime as PolluxDisplayTime,
    ExchangeStatus as PolluxExchangeStatus,
    FantasySelectionBetStatus as PolluxFantasySelectionBetStatus,
    FantasySelectionOrderStatus as PolluxFantasySelectionOrderStatus,
    HandicapType as PolluxHandicapType,
    InternalPromotionStage as PolluxInternalPromotionStage,
    LicenseType as PolluxLicenseType,
    MainBetStatus as PolluxMainBetStatus,
    OddsDisplayMode as PolluxOddsDisplayMode,
    OddsSorting as PolluxOddsSorting,
    PolluxPlaceOrderStatus,
    PlayerType as PolluxPlayerType,
    SelectionOutcome as PolluxSelectionOutcome,
    SelectionStatus as PolluxSelectionStatus,
    SiteStyle as PolluxSiteStyle,
    SubBetStatus as PolluxSubBetStatus,
    TiEnumSportType as PolluxTiEnumSportType,
    TiEnumMarketType,
    TiEnumOddsOption,
    TiEnumPriceStyle,
    TiEnumStatementDetailStatus,
} from '@/interface/pollux';
import type { TitansoftSportsSDKSylasEnumsRecommendType as RogueRecommendType, ComSbobetBookmakerSBEnumTiEnumSportType as RogueTiEnumSportType } from '@/interface/rogue';

export enum RoutePage {
    LiveStream = 'LiveStream',
    Results = 'Results',
    MyBets = 'MyBets',
    SettledBets = 'SettledBets',
    Preferences = 'Preferences',
    NotFound = 'NotFound',
    Exchange = 'Exchange',
    FantasySelectionHome = 'FantasySelectionHome',
    FantasySelectionContestPools = 'FantasySelectionContestPools',
    FantasySelectionContestDetail = 'FantasySelectionContestDetail',
    FantasySelectionMyBets = 'FantasySelectionMyBets',
    FantasySelectionMyBetDetail = 'FantasySelectionMyBetDetail',
    FantasySelectionSettledBets = 'FantasySelectionSettledBets',
}

export enum AsiaRoutePage {
    Layout = 'Layout',
    Home = 'Home',
    EFootballPage = 'EFootballPage',
    Jackpot = 'jackpot',
    MultipleSportsPage = 'MultipleSportsPage',
    SimulationSportsPage = 'SimulationSportsPage',
    SportsCupPage = 'SportsCupPage',
    SportsCup2Page = 'SportsCup2Page',
    SportLeaguePage = 'SportLeaguePage',
    TournamentOverview = 'TournamentOverview',
    TournamentTeams = 'TournamentTeams',
    TournamentMatches = 'TournamentMatches',
    TournamentPromotion = 'TournamentPromotion',
}

export enum EuroRoutePage {
    Layout = 'Layout',

    Home = 'Home',

    InPlay='InPlay',

    Multiples = 'Multiples',
    Multiples_MatchDetail = 'Multiples_MatchDetail',

    Layout_Sport = 'Layout_Sport',
    Sport = 'Sport',
    Sport_Matches = 'Sport_Matches',
    Sport_Matches_Date = 'Sport_Matches_Date',
    Sport_Competitions = 'Sport_Competitions',
    Sport_Outright = 'Sport_Outright',

    Layout_Region = 'Layout_Region',
    Region = 'Region',
    Region_Matches = 'Region_Matches',
    Region_Matches_Date = 'Region_Matches_Date',
    Region_Outright = 'Region_Outright',

    Layout_League = 'Layout_League',
    League = 'League',
    League_Matches = 'League_Matches',

    MatchDetail = 'MatchDetail',

    Exchange = 'Exchange',

    NotFound = 'NotFound',
}

export enum SiteStyle {
    Unknown = 'Unknown',
    Asia = 'Asia',
    Euro = 'Euro',
}

export namespace SiteStyle {
    export function fromPollux(polluxSiteStyle: PolluxSiteStyle) {
        switch (polluxSiteStyle) {
            case PolluxSiteStyle.Asia: return SiteStyle.Asia;
            case PolluxSiteStyle.Euro: return SiteStyle.Euro;
            default: return SiteStyle.Unknown;
        }
    }
    export function toPollux(siteStyle: SiteStyle): PolluxSiteStyle {
        switch (siteStyle) {
            case SiteStyle.Asia: return PolluxSiteStyle.Asia;
            case SiteStyle.Euro: return PolluxSiteStyle.Euro;
            default: return PolluxSiteStyle.Unknown;
        }
    }
}

export enum EuroDate {
    Unknown = 'Unknown',
    Today = 'Today',
    Tomorrow = 'Tomorrow',
    Future = 'Future',
}

export enum EuroMarket {
    _1X2 = '_1X2',
    MoneyLine = 'MoneyLine',
    TotalGoals = 'TotalGoals',
    Handicap = 'Handicap',
    GameLines = 'GameLines',
}

export namespace EuroDate {
    const mapping: Record<string, EuroDate> = {
        today: EuroDate.Today,
        tomorrow: EuroDate.Tomorrow,
        future: EuroDate.Future,
    };

    export function fromRoute(date: string) {
        return mapping[date.toLowerCase()] ?? EuroDate.Unknown;
    }

    export function toRoute(date: EuroDate) {
        const invertMap = invert(mapping);
        return invertMap[date] ?? invertMap[EuroDate.Today];
    }
}

export enum PromotionZone {
    None = 0,
    MultipleSports = 1,
    EFootball = 2,
    SportsCup = 3,
    SportsCup2 = 4,
    SportLeague = 5,
    TournamentCenter = 6,
    SimulationSports = 7,
}

export enum PromotionZoneType {
    Single = 'single',
    Multiple = 'multiple',
}

export enum PromotionZoneLayout {
    Default = 'Default',
    TournamentCenter = 'TournamentCenter',
}

export enum MultipleSportsZone {
    None,
    Olympic,
    AsianGames,
}

export enum SportType {
    Unknown = 0,
    Soccer = 1,
    Basketball = 2,
    Football = 3,
    IceHockey = 4,
    Badminton = 5,
    Pool = 6,
    MotorSport = 7,
    Tennis = 8,
    Baseball = 9,
    Volleyball = 10,
    Others = 11,
    Golf = 12,
    Boxing = 13,
    Cricket = 14,
    TableTennis = 15,
    Rugby = 16,
    Handball = 17,
    Cycling = 18,
    Athletics = 19,
    BeachSoccer = 20,
    Futsal = 21,
    Entertainment = 22,
    Financial = 23,
    Darts = 24,
    Olympic = 25,
    Lacrosse = 26,
    WaterPolo = 27,
    WinterSports = 28,
    Squash = 29,
    GeneralHockey = 30,
    MixedMartialArts = 31,
    Esports = 32,
    GaelicFootball = 33,
    Hurling = 34,
    MuayThai = 35,
    AussieRulesFootball = 36,
    Bandy = 37,
    WinterOlympic = 38,
    BeachVolleyball = 39,

    VirtualFootball = 5001,
    VirtualBasketball = 5002,
    VirtualRacing = 5003,
    EsportsIm = 5004,
    MuayThaiOneBx = 5005,
    FantasySelection = 6001,

    // project defined sportType (only for display, not a valid sportType number)
    EsportsForDisplay = 9001,
    MuayThaiForDisplay = 9002,
    Racing = 23111,
}

export namespace SportType {
    const sportTypeOddsApiMapping: Record<EnumSportType, SportType> = {
        [EnumSportType.Soccer]: SportType.Soccer,
        [EnumSportType.Basketball]: SportType.Basketball,
        [EnumSportType.Football]: SportType.Football,
        [EnumSportType.Ice_Hockey]: SportType.IceHockey,
        [EnumSportType.Badminton]: SportType.Badminton,
        [EnumSportType.Pool]: SportType.Pool,
        [EnumSportType.Motor_Sport]: SportType.MotorSport,
        [EnumSportType.Tennis]: SportType.Tennis,
        [EnumSportType.Baseball]: SportType.Baseball,
        [EnumSportType.Volleyball]: SportType.Volleyball,
        [EnumSportType.Others]: SportType.Others,
        [EnumSportType.Golf]: SportType.Golf,
        [EnumSportType.Boxing]: SportType.Boxing,
        [EnumSportType.Cricket]: SportType.Cricket,
        [EnumSportType.Table_Tennis]: SportType.TableTennis,
        [EnumSportType.Rugby]: SportType.Rugby,
        [EnumSportType.Handball]: SportType.Handball,
        [EnumSportType.Cycling]: SportType.Cycling,
        [EnumSportType.Athletics]: SportType.Athletics,
        [EnumSportType.Beach_Soccer]: SportType.BeachSoccer,
        [EnumSportType.Futsal]: SportType.Futsal,
        [EnumSportType.Entertainment]: SportType.Entertainment,
        [EnumSportType.Financial]: SportType.Financial,
        [EnumSportType.Darts]: SportType.Darts,
        [EnumSportType.Olympic]: SportType.Olympic,
        [EnumSportType.Lacrosse]: SportType.Lacrosse,
        [EnumSportType.Water_Polo]: SportType.WaterPolo,
        [EnumSportType.Winter_Sports]: SportType.WinterSports,
        [EnumSportType.Squash]: SportType.Squash,
        [EnumSportType.General_Hockey]: SportType.GeneralHockey,
        [EnumSportType.Mixed_Martial_Arts]: SportType.MixedMartialArts,
        [EnumSportType.E_Sports]: SportType.Esports,
        [EnumSportType.Gaelic_Football]: SportType.GaelicFootball,
        [EnumSportType.Hurling]: SportType.Hurling,
        [EnumSportType.Muay_Thai]: SportType.MuayThai,
        [EnumSportType.Aussie_Rules_Football]: SportType.AussieRulesFootball,
        [EnumSportType.Bandy]: SportType.Bandy,
        [EnumSportType.Winter_Olympic]: SportType.WinterOlympic,
        [EnumSportType.Beach_Volleyball]: SportType.BeachVolleyball,
    };

    export function fromOddsApi(oddsApiSportName: EnumSportType): SportType {
        const oddsApiSportType = sportTypeOddsApiMapping[oddsApiSportName];
        if (oddsApiSportType === undefined) {
            throw new Error(`transform sport type to odds api error: ${oddsApiSportName}, param oddsApiSportName: ${oddsApiSportName}`);
        }
        return oddsApiSportType;
    }

    export function toOddsApi(sportType: SportType): EnumSportType {
        const oddsApiSportType = (Object.keys(sportTypeOddsApiMapping) as Array<EnumSportType>)
            .find(key => sportTypeOddsApiMapping[key] === sportType);

        if (oddsApiSportType === undefined) {
            throw new Error(`transform sport type to odds api error: ${sportType}`);
        }
        return oddsApiSportType;
    }

    const sportTypePolluxMapping: Record<PolluxTiEnumSportType, SportType> = {
        [PolluxTiEnumSportType.Unknown]: SportType.Unknown,
        [PolluxTiEnumSportType.Soccer]: SportType.Soccer,
        [PolluxTiEnumSportType.Basketball]: SportType.Basketball,
        [PolluxTiEnumSportType.Football]: SportType.Football,
        [PolluxTiEnumSportType.Ice_Hockey]: SportType.IceHockey,
        [PolluxTiEnumSportType.Badminton]: SportType.Badminton,
        [PolluxTiEnumSportType.Pool]: SportType.Pool,
        [PolluxTiEnumSportType.Motor_Sport]: SportType.MotorSport,
        [PolluxTiEnumSportType.Tennis]: SportType.Tennis,
        [PolluxTiEnumSportType.Baseball]: SportType.Baseball,
        [PolluxTiEnumSportType.Volleyball]: SportType.Volleyball,
        [PolluxTiEnumSportType.Others]: SportType.Others,
        [PolluxTiEnumSportType.Golf]: SportType.Golf,
        [PolluxTiEnumSportType.Boxing]: SportType.Boxing,
        [PolluxTiEnumSportType.Cricket]: SportType.Cricket,
        [PolluxTiEnumSportType.Table_Tennis]: SportType.TableTennis,
        [PolluxTiEnumSportType.Rugby]: SportType.Rugby,
        [PolluxTiEnumSportType.Handball]: SportType.Handball,
        [PolluxTiEnumSportType.Cycling]: SportType.Cycling,
        [PolluxTiEnumSportType.Athletics]: SportType.Athletics,
        [PolluxTiEnumSportType.Beach_Soccer]: SportType.BeachSoccer,
        [PolluxTiEnumSportType.Futsal]: SportType.Futsal,
        [PolluxTiEnumSportType.Entertainment]: SportType.Entertainment,
        [PolluxTiEnumSportType.Financial]: SportType.Financial,
        [PolluxTiEnumSportType.Darts]: SportType.Darts,
        [PolluxTiEnumSportType.Olympic]: SportType.Olympic,
        [PolluxTiEnumSportType.Lacrosse]: SportType.Lacrosse,
        [PolluxTiEnumSportType.Water_Polo]: SportType.WaterPolo,
        [PolluxTiEnumSportType.Winter_Sports]: SportType.WinterSports,
        [PolluxTiEnumSportType.Squash]: SportType.Squash,
        [PolluxTiEnumSportType.General_Hockey]: SportType.GeneralHockey,
        [PolluxTiEnumSportType.Mixed_Martial_Arts]: SportType.MixedMartialArts,
        [PolluxTiEnumSportType.E_Sports]: SportType.Esports,
        [PolluxTiEnumSportType.Gaelic_Football]: SportType.GaelicFootball,
        [PolluxTiEnumSportType.Hurling]: SportType.Hurling,
        [PolluxTiEnumSportType.Muay_Thai]: SportType.MuayThai,
        [PolluxTiEnumSportType.Aussie_Rules_Football]: SportType.AussieRulesFootball,
        [PolluxTiEnumSportType.Bandy]: SportType.Bandy,
        [PolluxTiEnumSportType.Winter_Olympic]: SportType.WinterOlympic,
        [PolluxTiEnumSportType.Beach_Volleyball]: SportType.BeachVolleyball,
    };
    export function fromPollux(sportType: PolluxTiEnumSportType): SportType {
        return sportTypePolluxMapping[sportType];
    }

    export function toPollux(sportType: SportType): PolluxTiEnumSportType {
        const polluxSportType = (Object.keys(sportTypePolluxMapping).map(x => parseInt(x)) as Array<PolluxTiEnumSportType>)
            .find(key => sportTypePolluxMapping[key] === sportType);
        if (polluxSportType === undefined) {
            console.error(`transform sport type to pollux error: ${sportType}`);
            return PolluxTiEnumSportType.Unknown;
        }
        return polluxSportType;
    }

    const sportTypeRouteMapping: Record<string, SportType> = {
        'unknown': SportType.Unknown,
        'football': SportType.Soccer,
        'basketball': SportType.Basketball,
        'american-football': SportType.Football,
        'ice-hockey': SportType.IceHockey,
        'badminton': SportType.Badminton,
        'pool-snooker': SportType.Pool,
        'motor-sport': SportType.MotorSport,
        'tennis': SportType.Tennis,
        'baseball': SportType.Baseball,
        'volleyball': SportType.Volleyball,
        'others': SportType.Others,
        'golf': SportType.Golf,
        'boxing': SportType.Boxing,
        'cricket': SportType.Cricket,
        'table-tennis': SportType.TableTennis,
        'rugby': SportType.Rugby,
        'handball': SportType.Handball,
        'cycling': SportType.Cycling,
        'athletics': SportType.Athletics,
        'beach-soccer': SportType.BeachSoccer,
        'futsal': SportType.Futsal,
        'special': SportType.Entertainment,
        'financial': SportType.Financial,
        'darts': SportType.Darts,
        'olympics': SportType.Olympic,
        'lacrosse': SportType.Lacrosse,
        'water-polo': SportType.WaterPolo,
        'winter-sports': SportType.WinterSports,
        'squash': SportType.Squash,
        'hockey': SportType.GeneralHockey,
        'mixed-martial-arts': SportType.MixedMartialArts,
        'e-sports': SportType.Esports,
        'gaelic-football': SportType.GaelicFootball,
        'hurling': SportType.Hurling,
        'muay-thai': SportType.MuayThai,
        'aussie-rules-football': SportType.AussieRulesFootball,
        'bandy': SportType.Bandy,
        'winter-olympics': SportType.WinterOlympic,
        'beach-volleyball': SportType.BeachVolleyball,
    };

    export function fromRoute(sportRoute: string) {
        return sportTypeRouteMapping[sportRoute.toLowerCase()] ?? SportType.Unknown;
    }

    export function toRoute(sportType: SportType) {
        const invertMap = invert(sportTypeRouteMapping);
        return invertMap[sportType] ?? invertMap[SportType.Soccer];
    }

    const sportTypeKratosToRogueMapping: Record<SportType, RogueTiEnumSportType> = {
        [SportType.Unknown]: 0,
        [SportType.Soccer]: 1,
        [SportType.Basketball]: 2,
        [SportType.Football]: 3,
        [SportType.IceHockey]: 4,
        [SportType.Badminton]: 5,
        [SportType.Pool]: 6,
        [SportType.MotorSport]: 7,
        [SportType.Tennis]: 8,
        [SportType.Baseball]: 9,
        [SportType.Volleyball]: 10,
        [SportType.Others]: 11,
        [SportType.Golf]: 12,
        [SportType.Boxing]: 13,
        [SportType.Cricket]: 14,
        [SportType.TableTennis]: 15,
        [SportType.Rugby]: 16,
        [SportType.Handball]: 17,
        [SportType.Cycling]: 18,
        [SportType.Athletics]: 19,
        [SportType.BeachSoccer]: 20,
        [SportType.Futsal]: 21,
        [SportType.Entertainment]: 22,
        [SportType.Financial]: 23,
        [SportType.Darts]: 24,
        [SportType.Olympic]: 25,
        [SportType.Lacrosse]: 26,
        [SportType.WaterPolo]: 27,
        [SportType.WinterSports]: 28,
        [SportType.Squash]: 29,
        [SportType.GeneralHockey]: 30,
        [SportType.MixedMartialArts]: 31,
        [SportType.Esports]: 32,
        [SportType.GaelicFootball]: 33,
        [SportType.Hurling]: 34,
        [SportType.MuayThai]: 35,
        [SportType.AussieRulesFootball]: 36,
        [SportType.Bandy]: 37,
        [SportType.WinterOlympic]: 38,
        [SportType.BeachVolleyball]: 39,
        [SportType.VirtualFootball]: 0,
        [SportType.VirtualBasketball]: 0,
        [SportType.VirtualRacing]: 0,
        [SportType.EsportsIm]: 0,
        [SportType.EsportsForDisplay]: 0,
        [SportType.MuayThaiOneBx]: 0,
        [SportType.MuayThaiForDisplay]: 0,
        [SportType.Racing]: 0,
        [SportType.FantasySelection]: 0,
    };

    export function toRogue(sportType: SportType): RogueTiEnumSportType {
        return sportTypeKratosToRogueMapping[sportType];
    }
}

export enum VirtualSportsType{
    Football = 1,
    Basketball = 2
}

export enum OddsApiSportType {
    Unknown = 0,
    Soccer = 1,
    Basketball = 2,
    Football = 3,
    Hockey = 4,
    Badminton = 5,
    Pool = 6,
    Motor_Sport = 7,
    Tennis = 8,
    Baseball = 9,
    Volleyball = 10,
    Others = 11,
    Golf = 12,
    Boxing = 13,
    Cricket = 14,
    Table_Tennis = 15,
    Rugby = 16,
    Handball = 17,
    Cycling = 18,
    Athletics = 19,
    Beach_Soccer = 20,
    Futsal = 21,
    Entertainment = 22,
    Financial = 23,
    Darts = 24,
    Olympic = 25,
    Lacrosse = 26,
    Water_Polo = 27,
    Winter_Sports = 28,
    Squash = 29,
    Field_Hockey = 30,
    Mixed_Martial_Arts = 31,
    E_Sports = 32,
    Gaelic_Football = 33,
    Hurling = 34,
    Muay_Thai = 35,
    Aussie_Rules_Football = 36,
    Bandy = 37,
    Winter_Olympic = 38,
    Beach_Volleyball = 39
}

export enum MarketPage {
    Unknown = 0,
    Today = 1,
    EarlyMarket = 2,
    Live = 3,
    MixParlay = 4,
    Outright = 5,
    MyFavorites = 6,
    All = 7,

    VirtualFootball = 5001,
    VirtualBasketball = 5002,
    VirtualRacing = 5003,
    VirtualSboCup = 5005,
    VirtualEuroCup = 5006,
    VirtualChampionsCup = 5007,
    VirtualAsianCup = 5008,
}

export enum EnumLanguage {
    EN = 'EN',
    ID_ID = 'ID_ID',
    JA_JP = 'JA_JP',
    KO_KR = 'KO_KR',
    MY_MM = 'MY_MM',
    TH_TH = 'TH_TH',
    VI_VN = 'VI_VN',
    ZH_CN = 'ZH_CN',
    PT_BR = 'PT_BR',
    KM_KH = 'KM_KH',
    BN_BD = 'BN_BD',
    MS_MY = 'MS_MY',
}

export namespace EnumLanguage {
    export function toOddsApi(languageType: EnumLanguage): EnumLanguageType {
        const languageTypeMapping: Record<EnumLanguage, EnumLanguageType> = {
            [EnumLanguage.EN]: EnumLanguageType.EN,
            [EnumLanguage.ID_ID]: EnumLanguageType.ID_ID,
            [EnumLanguage.JA_JP]: EnumLanguageType.JA_JP,
            [EnumLanguage.KO_KR]: EnumLanguageType.KO_KR,
            [EnumLanguage.MY_MM]: EnumLanguageType.MY_MM,
            [EnumLanguage.TH_TH]: EnumLanguageType.TH_TH,
            [EnumLanguage.VI_VN]: EnumLanguageType.VI_VN,
            [EnumLanguage.ZH_CN]: EnumLanguageType.ZH_CN,
            [EnumLanguage.PT_BR]: EnumLanguageType.PT_BR,
            [EnumLanguage.KM_KH]: EnumLanguageType.KM_KH,
            [EnumLanguage.BN_BD]: EnumLanguageType.BN_BD,
            [EnumLanguage.MS_MY]: EnumLanguageType.MS_MY,
        };
        const mappedLanguageType = languageTypeMapping[languageType];
        if (mappedLanguageType === undefined) {
            console.error(`Failed to transform EnumLanguage toOddsApi: ${languageType}`);
        }
        return mappedLanguageType;
    }

    export function fromOddsApi(lang: EnumLanguageType): EnumLanguage {
        switch (lang) {
            case EnumLanguageType.EN: return EnumLanguage.EN;
            case EnumLanguageType.ID_ID: return EnumLanguage.ID_ID;
            case EnumLanguageType.JA_JP: return EnumLanguage.JA_JP;
            case EnumLanguageType.KO_KR: return EnumLanguage.KO_KR;
            case EnumLanguageType.MY_MM: return EnumLanguage.MY_MM;
            case EnumLanguageType.TH_TH: return EnumLanguage.TH_TH;
            case EnumLanguageType.VI_VN: return EnumLanguage.VI_VN;
            case EnumLanguageType.ZH_CN: return EnumLanguage.ZH_CN;
            case EnumLanguageType.ZH_TW: return EnumLanguage.ZH_CN;
            case EnumLanguageType.PT_BR: return EnumLanguage.PT_BR;
            case EnumLanguageType.KM_KH: return EnumLanguage.KM_KH;
            case EnumLanguageType.BN_BD: return EnumLanguage.BN_BD;
            case EnumLanguageType.MS_MY: return EnumLanguage.MS_MY;

            default:
                console.warn(`Failed to transform EnumLanguage fromOddsApi: ${lang}`);
                return EnumLanguage.EN;
        }
    }

    export function fromPlatform(lang: string): EnumLanguage {
        switch (lang.toLowerCase().replaceAll('_', '-')) {
            case 'en': return EnumLanguage.EN;
            case 'id-id': return EnumLanguage.ID_ID;
            case 'ja-jp': return EnumLanguage.JA_JP;
            case 'ko-kr': return EnumLanguage.KO_KR;
            case 'my-mm': return EnumLanguage.MY_MM;
            case 'th-th': return EnumLanguage.TH_TH;
            case 'vi-vn': return EnumLanguage.VI_VN;
            case 'zh-cn': return EnumLanguage.ZH_CN;
            case 'zh-tw': return EnumLanguage.ZH_CN;
            case 'pt-br': return EnumLanguage.PT_BR;
            case 'km-kh': return EnumLanguage.KM_KH;
            case 'bn-bd': return EnumLanguage.BN_BD;
            case 'ms-my': return EnumLanguage.MS_MY;

            default:
                console.warn(`Failed to transform EnumLanguage fromPlatform: ${lang}`);
                return EnumLanguage.EN;
        }
    }

    export function toPlatform(lang: EnumLanguage): string {
        switch (lang) {
            case EnumLanguage.EN: return 'en';
            case EnumLanguage.ID_ID: return 'id-id';
            case EnumLanguage.JA_JP: return 'ja-jp';
            case EnumLanguage.KO_KR: return 'ko-kr';
            case EnumLanguage.MY_MM: return 'my-mm';
            case EnumLanguage.TH_TH: return 'th-th';
            case EnumLanguage.VI_VN: return 'vi-vn';
            case EnumLanguage.ZH_CN: return 'zh-cn';
            case EnumLanguage.PT_BR: return 'pt-br';
            case EnumLanguage.KM_KH: return 'km-kh';
            case EnumLanguage.BN_BD: return 'bn-bd';
            case EnumLanguage.MS_MY: return 'ms-my';

            default:
                console.warn(`Failed to transform EnumLanguage toPlatform: ${lang}`);
                return 'en';
        }
    }

    export function fromPollux(lang: string): EnumLanguage {
        switch (lang) {
            case 'EN': return EnumLanguage.EN;
            case 'ID_ID': return EnumLanguage.ID_ID;
            case 'JA_JP': return EnumLanguage.JA_JP;
            case 'KO_KR': return EnumLanguage.KO_KR;
            case 'MY_MM': return EnumLanguage.MY_MM;
            case 'TH_TH': return EnumLanguage.TH_TH;
            case 'VI_VN': return EnumLanguage.VI_VN;
            case 'ZH_CN': return EnumLanguage.ZH_CN;
            case 'ZH_TW': return EnumLanguage.ZH_CN;
            case 'PT_BR': return EnumLanguage.PT_BR;
            case 'KM_KH': return EnumLanguage.KM_KH;
            case 'BN_BD': return EnumLanguage.BN_BD;
            case 'MS_MY': return EnumLanguage.MS_MY;

            default:
                console.warn(`Failed to transform EnumLanguage fromPollux: ${lang}`);
                return EnumLanguage.EN;
        }
    }

    export function toPollux(lang: EnumLanguage): string {
        switch (lang) {
            case EnumLanguage.EN: return 'EN';
            case EnumLanguage.ID_ID: return 'ID_ID';
            case EnumLanguage.JA_JP: return 'JA_JP';
            case EnumLanguage.KO_KR: return 'KO_KR';
            case EnumLanguage.MY_MM: return 'MY_MM';
            case EnumLanguage.TH_TH: return 'TH_TH';
            case EnumLanguage.VI_VN: return 'VI_VN';
            case EnumLanguage.ZH_CN: return 'ZH_CN';
            case EnumLanguage.PT_BR: return 'PT_BR';
            case EnumLanguage.KM_KH: return 'KM_KH';
            case EnumLanguage.BN_BD: return 'BN_BD';
            case EnumLanguage.MS_MY: return 'MS_MY';

            default:
                console.warn(`Failed to transform EnumLanguage toPollux: ${lang}`);
                return 'EN';
        }
    }

    export function toLiveCourt(lang: EnumLanguage): string {
        switch (lang) {
            case EnumLanguage.EN: return 'en';
            case EnumLanguage.ID_ID: return 'id';
            case EnumLanguage.JA_JP: return 'ja';
            case EnumLanguage.KO_KR: return 'ko';
            case EnumLanguage.TH_TH: return 'th';
            case EnumLanguage.VI_VN: return 'vi';
            case EnumLanguage.ZH_CN: return 'zh';
            case EnumLanguage.PT_BR: return 'pt';
            case EnumLanguage.KM_KH: return 'km';
            default: return 'en';
        }
    }

    export function toStatistics(lang: EnumLanguage): string {
        switch (lang) {
            case EnumLanguage.ZH_CN: return 'zh';
            case EnumLanguage.TH_TH: return 'th';
            case EnumLanguage.VI_VN: return 'vi';
            case EnumLanguage.ID_ID: return 'id';
            case EnumLanguage.JA_JP: return 'ja';
            case EnumLanguage.KO_KR: return 'ko';
            default: return 'en';
        }
    }
}

export enum PlayerType {
    B2B = 0,
    B2C = 1,
    B2B2C = 2,
}

export namespace PlayerType {
    export function fromPollux(playerType: PolluxPlayerType): PlayerType {
        switch (playerType) {
            case PolluxPlayerType.B2B: return PlayerType.B2B;
            case PolluxPlayerType.B2C: return PlayerType.B2C;
            case PolluxPlayerType.B2B2C: return PlayerType.B2B2C;
            default:
                throw new Error(`transform user type from pollux error: ${playerType}`);
        }
    }
}

export enum LicenseType {
    MNL = 0,
    IOM = 1,
}

export namespace LicenseType {
    export function fromPollux(license: PolluxLicenseType): LicenseType {
        switch (license) {
            case PolluxLicenseType.MNL: return LicenseType.MNL;
            case PolluxLicenseType.IOM: return LicenseType.IOM;
            default: throw new Error(`transform license type from pollux error: ${license}`);
        }
    }
}

export enum Sound{
    Unknown = 'none',
    Whistle = 'sound_01',
    GongHit = 'sound_02',
    DoorBell = 'sound_03',
    FlagRising = 'sound_04',
    DrumRoll = 'sound_05',
    OleOle = 'sound_06',
    Drum = 'sound_07'
}

export enum MarketType {
    Unknown = 0,
    Handicap = 1,
    OddEven = 2,
    OverUnder = 3,
    CorrectScore = 4,
    _1X2 = 5,
    TotalGoal = 6,
    FH_Handicap = 7,
    FH_1X2 = 8,
    FH_OverUnder = 9,
    HTFT = 10,
    MoneyLine = 11,
    FH_OddEven = 12,
    FGLG = 13,
    FH_CorrectScore = 14,
    DoubleChance = 15,
    LiveScore = 16,
    FH_LiveScore = 17,
    Dynamic = 18,
    SH_CorrectScore = 19,
    Game = 38,
    OutRight = 39,
    MixParlay = 40,
    BetBuilder = 41,
}

export namespace MarketType {
    const marketTypeOddsApiMapping: Record<EnumMarketType, MarketType> = {
        [EnumMarketType.Unknown]: MarketType.Unknown,
        [EnumMarketType.Handicap]: MarketType.Handicap,
        [EnumMarketType.OddEven]: MarketType.OddEven,
        [EnumMarketType.OverUnder]: MarketType.OverUnder,
        [EnumMarketType.CorrectScore]: MarketType.CorrectScore,
        [EnumMarketType._1X2]: MarketType._1X2,
        [EnumMarketType.TotalGoal]: MarketType.TotalGoal,
        [EnumMarketType.FH_Handicap]: MarketType.FH_Handicap,
        [EnumMarketType.FH_1X2]: MarketType.FH_1X2,
        [EnumMarketType.FH_OverUnder]: MarketType.FH_OverUnder,
        [EnumMarketType.HTFT]: MarketType.HTFT,
        [EnumMarketType.MoneyLine]: MarketType.MoneyLine,
        [EnumMarketType.FH_OddEven]: MarketType.FH_OddEven,
        [EnumMarketType.FGLG]: MarketType.FGLG,
        [EnumMarketType.FH_CorrectScore]: MarketType.FH_CorrectScore,
        [EnumMarketType.DoubleChance]: MarketType.DoubleChance,
        [EnumMarketType.LiveScore]: MarketType.LiveScore,
        [EnumMarketType.FH_LiveScore]: MarketType.FH_LiveScore,
        [EnumMarketType.Game]: MarketType.Game,
        [EnumMarketType.OutRight]: MarketType.OutRight,
        [EnumMarketType.MixParlay]: MarketType.MixParlay,
        [EnumMarketType.SH_CorrectScore]: MarketType.SH_CorrectScore,
    };
    export function fromOddsApi(oddsApiMarketType: EnumMarketType): MarketType {
        return marketTypeOddsApiMapping[oddsApiMarketType];
    }

    export function toOddsApi(marketType: MarketType): EnumMarketType {
        const oddsApiMarketType = (Object.keys(marketTypeOddsApiMapping) as Array<EnumMarketType>)
            .find(key => marketTypeOddsApiMapping[key] === marketType);
        if (oddsApiMarketType === undefined) {
            console.error(`transform market type to odds api error: ${marketType}`);
            return EnumMarketType.Unknown;
        }
        return oddsApiMarketType;
    }

    const marketTypePolluxMapping: Record<TiEnumMarketType, MarketType> = {
        [TiEnumMarketType.Unknown]: MarketType.Unknown,
        [TiEnumMarketType.Handicap]: MarketType.Handicap,
        [TiEnumMarketType.OddEven]: MarketType.OddEven,
        [TiEnumMarketType.OverUnder]: MarketType.OverUnder,
        [TiEnumMarketType.CorrectScore]: MarketType.CorrectScore,
        [TiEnumMarketType._1X2]: MarketType._1X2,
        [TiEnumMarketType.TotalGoal]: MarketType.TotalGoal,
        [TiEnumMarketType.FH_Handicap]: MarketType.FH_Handicap,
        [TiEnumMarketType.FH_1X2]: MarketType.FH_1X2,
        [TiEnumMarketType.FH_OverUnder]: MarketType.FH_OverUnder,
        [TiEnumMarketType.HTFT]: MarketType.HTFT,
        [TiEnumMarketType.MoneyLine]: MarketType.MoneyLine,
        [TiEnumMarketType.FH_OddEven]: MarketType.FH_OddEven,
        [TiEnumMarketType.FGLG]: MarketType.FGLG,
        [TiEnumMarketType.FH_CorrectScore]: MarketType.FH_CorrectScore,
        [TiEnumMarketType.DoubleChance]: MarketType.DoubleChance,
        [TiEnumMarketType.LiveScore]: MarketType.LiveScore,
        [TiEnumMarketType.FH_LiveScore]: MarketType.FH_LiveScore,
        [TiEnumMarketType.Game]: MarketType.Game,
        [TiEnumMarketType.OutRight]: MarketType.OutRight,
        [TiEnumMarketType.MixParlay]: MarketType.MixParlay,
        [TiEnumMarketType.BetBuilder]: MarketType.BetBuilder,
        [TiEnumMarketType.Dynamic]: MarketType.Dynamic,
        [TiEnumMarketType.SH_CorrectScore]: MarketType.SH_CorrectScore,
    };
    export function fromPollux(marketType: TiEnumMarketType): MarketType {
        return marketTypePolluxMapping[marketType];
    }

    export function toPollux(marketType: MarketType): TiEnumMarketType {
        const polluxMarketType = (Object.keys(marketTypePolluxMapping).map(x => parseInt(x)) as Array<TiEnumMarketType>)
            .find(key => marketTypePolluxMapping[key] === marketType);
        if (polluxMarketType === undefined) {
            console.error(`transform market type to pollux error: ${marketType}`);
            return TiEnumMarketType.Unknown;
        }
        return polluxMarketType;
    }
}

// for header display
export enum MarketTypeHeader{
    More = 1000,
}

export enum OddsDisplayBlockType {
    Time = 'time',
    Team = 'event',
    FullTime = 'ft',
    FirstHalf = 'ht',
    More = 'more',
    FirstQuarter = 'first_quarter',
    GameHandicap = 'game_handicap',
    TotalMatchPoints = 'total_match_points',
    FirstPeriod = 'first_period',
    FirstInningRuns = 'first_inning_runs'
}

export enum OddsOption {
    Unknown = '',
    Home = 'h',
    Away ='a',
    Over ='h',
    Under ='a',
    Odd ='h',
    Even = 'a',
    _1X2_1 = '1',
    _1X2_X = 'x',
    _1X2_2 = '2',
    ML_1 = '1',
    ML_2 = '2',
    HTFT_HH = 'hh',
    HTFT_HA = 'ha',
    HTFT_HD = 'hd',
    HTFT_AH = 'ah',
    HTFT_AA = 'aa',
    HTFT_AD = 'ad',
    HTFT_DH = 'dh',
    HTFT_DA = 'da',
    HTFT_DD = 'dd',
    FGLG_HF = 'hf',
    FGLG_HL = 'hl',
    FGLG_AF = 'af',
    FGLG_AL = 'al',
    FGLG_NG = 'ng',
    TG_0_1 = '0-1',
    TG_2_3 = '2-3',
    TG_4_6 = '4-6',
    TG_7_Up = '7-over',
    CS_0_0 = '0:0',
    CS_0_1 = '0:1',
    CS_0_2 = '0:2',
    CS_0_3 = '0:3',
    CS_0_4 = '0:4',
    CS_1_0 = '1:0',
    CS_1_1 = '1:1',
    CS_1_2 = '1:2',
    CS_1_3 = '1:3',
    CS_1_4 = '1:4',
    CS_2_0 = '2:0',
    CS_2_1 = '2:1',
    CS_2_2 = '2:2',
    CS_2_3 = '2:3',
    CS_2_4 = '2:4',
    CS_3_0 = '3:0',
    CS_3_1 = '3:1',
    CS_3_2 = '3:2',
    CS_3_3 = '3:3',
    CS_3_4 = '3:4',
    CS_4_0 = '4:0',
    CS_4_1 = '4:1',
    CS_4_2 = '4:2',
    CS_4_3 = '4:3',
    CS_4_4 = '4:4',
    CS_Others = 'o',
    DC_1X = '1x',
    DC_2X = 'x2',
    DC_12 = '12',
    LS_1 = '1',
    LS_X = 'x',
    LS_2 = '2',
    OR = 'or',
}

export namespace OddsOption {
    export function fromPollux(oddsOption: TiEnumOddsOption): OddsOption {
        const oddsOptionMapping: Partial<Record<TiEnumOddsOption, OddsOption>> = {
            [TiEnumOddsOption.Unknown]: OddsOption.Unknown,
            [TiEnumOddsOption.Home]: OddsOption.Home,
            [TiEnumOddsOption.Away]: OddsOption.Away,
            [TiEnumOddsOption.Over]: OddsOption.Over,
            [TiEnumOddsOption.Under]: OddsOption.Under,
            [TiEnumOddsOption.Odd]: OddsOption.Odd,
            [TiEnumOddsOption.Even]: OddsOption.Even,
            [TiEnumOddsOption._1X2_1]: OddsOption._1X2_1,
            [TiEnumOddsOption._1X2_X]: OddsOption._1X2_X,
            [TiEnumOddsOption._1X2_2]: OddsOption._1X2_2,
            [TiEnumOddsOption.ML_1]: OddsOption.ML_1,
            [TiEnumOddsOption.ML_2]: OddsOption.ML_2,
            [TiEnumOddsOption.HTFT_HH]: OddsOption.HTFT_HH,
            [TiEnumOddsOption.HTFT_HA]: OddsOption.HTFT_HA,
            [TiEnumOddsOption.HTFT_HD]: OddsOption.HTFT_HD,
            [TiEnumOddsOption.HTFT_AH]: OddsOption.HTFT_AH,
            [TiEnumOddsOption.HTFT_AA]: OddsOption.HTFT_AA,
            [TiEnumOddsOption.HTFT_AD]: OddsOption.HTFT_AD,
            [TiEnumOddsOption.HTFT_DH]: OddsOption.HTFT_DH,
            [TiEnumOddsOption.HTFT_DA]: OddsOption.HTFT_DA,
            [TiEnumOddsOption.HTFT_DD]: OddsOption.HTFT_DD,
            [TiEnumOddsOption.FGLG_HF]: OddsOption.FGLG_HF,
            [TiEnumOddsOption.FGLG_HL]: OddsOption.FGLG_HL,
            [TiEnumOddsOption.FGLG_AF]: OddsOption.FGLG_AF,
            [TiEnumOddsOption.FGLG_AL]: OddsOption.FGLG_AL,
            [TiEnumOddsOption.FGLG_NG]: OddsOption.FGLG_NG,
            [TiEnumOddsOption.TG_0_1]: OddsOption.TG_0_1,
            [TiEnumOddsOption.TG_2_3]: OddsOption.TG_2_3,
            [TiEnumOddsOption.TG_4_6]: OddsOption.TG_4_6,
            [TiEnumOddsOption.TG_7_Up]: OddsOption.TG_7_Up,
            [TiEnumOddsOption.CS_0_0]: OddsOption.CS_0_0,
            [TiEnumOddsOption.CS_0_1]: OddsOption.CS_0_1,
            [TiEnumOddsOption.CS_0_2]: OddsOption.CS_0_2,
            [TiEnumOddsOption.CS_0_3]: OddsOption.CS_0_3,
            [TiEnumOddsOption.CS_0_4]: OddsOption.CS_0_4,
            [TiEnumOddsOption.CS_1_0]: OddsOption.CS_1_0,
            [TiEnumOddsOption.CS_1_1]: OddsOption.CS_1_1,
            [TiEnumOddsOption.CS_1_2]: OddsOption.CS_1_2,
            [TiEnumOddsOption.CS_1_3]: OddsOption.CS_1_3,
            [TiEnumOddsOption.CS_1_4]: OddsOption.CS_1_4,
            [TiEnumOddsOption.CS_2_0]: OddsOption.CS_2_0,
            [TiEnumOddsOption.CS_2_1]: OddsOption.CS_2_1,
            [TiEnumOddsOption.CS_2_2]: OddsOption.CS_2_2,
            [TiEnumOddsOption.CS_2_3]: OddsOption.CS_2_3,
            [TiEnumOddsOption.CS_2_4]: OddsOption.CS_2_4,
            [TiEnumOddsOption.CS_3_0]: OddsOption.CS_3_0,
            [TiEnumOddsOption.CS_3_1]: OddsOption.CS_3_1,
            [TiEnumOddsOption.CS_3_2]: OddsOption.CS_3_2,
            [TiEnumOddsOption.CS_3_3]: OddsOption.CS_3_3,
            [TiEnumOddsOption.CS_3_4]: OddsOption.CS_3_4,
            [TiEnumOddsOption.CS_4_0]: OddsOption.CS_4_0,
            [TiEnumOddsOption.CS_4_1]: OddsOption.CS_4_1,
            [TiEnumOddsOption.CS_4_2]: OddsOption.CS_4_2,
            [TiEnumOddsOption.CS_4_3]: OddsOption.CS_4_3,
            [TiEnumOddsOption.CS_4_4]: OddsOption.CS_4_4,
            [TiEnumOddsOption.OR]: OddsOption.OR,
            [TiEnumOddsOption.DC_1X]: OddsOption.DC_1X,
            [TiEnumOddsOption.DC_2X]: OddsOption.DC_2X,
            [TiEnumOddsOption.DC_12]: OddsOption.DC_12,
            [TiEnumOddsOption.LS_1]: OddsOption.LS_1,
            [TiEnumOddsOption.LS_X]: OddsOption.LS_X,
            [TiEnumOddsOption.LS_2]: OddsOption.LS_2,
            [TiEnumOddsOption.CS_Others]: OddsOption.CS_Others,
        };
        const oddsOptionValue = oddsOptionMapping[oddsOption];
        if (oddsOptionValue === undefined) {
            console.error(`transform odds option from pollux error: ${oddsOption}`);
            return OddsOption.Unknown;
        }
        return oddsOptionValue;
    }

    // reference: GambitCache OddsModel.cs
    export function fromOddsApi(option: string, marketType: MarketType): OddsOption {
        switch (marketType) {
            case MarketType.Handicap:
            case MarketType.FH_Handicap:
                switch (option) {
                    case 'h': return OddsOption.Home;
                    case 'a': return OddsOption.Away;
                    default: console.error('Unknown OddsOption', MarketType[marketType], option); return OddsOption.Unknown;
                }
            case MarketType.OddEven:
            case MarketType.FH_OddEven:
                switch (option) {
                    case 'h': return OddsOption.Odd;
                    case 'a': return OddsOption.Even;
                    default: console.error('Unknown OddsOption', MarketType[marketType], option); return OddsOption.Unknown;
                }
            case MarketType.OverUnder:
            case MarketType.FH_OverUnder:
                switch (option) {
                    case 'h': return OddsOption.Over;
                    case 'a': return OddsOption.Under;
                    default: console.error('Unknown OddsOption', MarketType[marketType], option); return OddsOption.Unknown;
                }
            case MarketType.CorrectScore:
            case MarketType.FH_CorrectScore:
            case MarketType.SH_CorrectScore:
                switch (option) {
                    case '0:0': return OddsOption.CS_0_0;
                    case '0:1': return OddsOption.CS_0_1;
                    case '0:2': return OddsOption.CS_0_2;
                    case '0:3': return OddsOption.CS_0_3;
                    case '0:4': return OddsOption.CS_0_4;
                    case '1:0': return OddsOption.CS_1_0;
                    case '1:1': return OddsOption.CS_1_1;
                    case '1:2': return OddsOption.CS_1_2;
                    case '1:3': return OddsOption.CS_1_3;
                    case '1:4': return OddsOption.CS_1_4;
                    case '2:0': return OddsOption.CS_2_0;
                    case '2:1': return OddsOption.CS_2_1;
                    case '2:2': return OddsOption.CS_2_2;
                    case '2:3': return OddsOption.CS_2_3;
                    case '2:4': return OddsOption.CS_2_4;
                    case '3:0': return OddsOption.CS_3_0;
                    case '3:1': return OddsOption.CS_3_1;
                    case '3:2': return OddsOption.CS_3_2;
                    case '3:3': return OddsOption.CS_3_3;
                    case '3:4': return OddsOption.CS_3_4;
                    case '4:0': return OddsOption.CS_4_0;
                    case '4:1': return OddsOption.CS_4_1;
                    case '4:2': return OddsOption.CS_4_2;
                    case '4:3': return OddsOption.CS_4_3;
                    case '4:4': return OddsOption.CS_4_4;
                    case 'O': return OddsOption.CS_Others;
                    default: console.error('Unknown OddsOption', MarketType[marketType], option); return OddsOption.Unknown;
                }
            case MarketType._1X2:
            case MarketType.FH_1X2:
                switch (option.toUpperCase()) {
                    case '1': return OddsOption._1X2_1;
                    case '2': return OddsOption._1X2_2;
                    case 'X': return OddsOption._1X2_X;
                    default: console.error('Unknown OddsOption', MarketType[marketType], option); return OddsOption.Unknown;
                }
            case MarketType.TotalGoal:
                switch (option.toUpperCase()) {
                    case '0-1': return OddsOption.TG_0_1;
                    case '2-3': return OddsOption.TG_2_3;
                    case '4-6': return OddsOption.TG_4_6;
                    case '7-OVER': return OddsOption.TG_7_Up;
                    default: console.error('Unknown OddsOption', MarketType[marketType], option); return OddsOption.Unknown;
                }
            case MarketType.HTFT:
                switch (option) {
                    case 'AA': return OddsOption.HTFT_AA;
                    case 'AD': return OddsOption.HTFT_AD;
                    case 'AH': return OddsOption.HTFT_AH;
                    case 'DA': return OddsOption.HTFT_DA;
                    case 'DD': return OddsOption.HTFT_DD;
                    case 'DH': return OddsOption.HTFT_DH;
                    case 'HA': return OddsOption.HTFT_HA;
                    case 'HD': return OddsOption.HTFT_HD;
                    case 'HH': return OddsOption.HTFT_HH;
                    default: console.error('Unknown OddsOption', MarketType[marketType], option); return OddsOption.Unknown;
                }
            case MarketType.MoneyLine:
                switch (option) {
                    case '1': return OddsOption.ML_1;
                    case '2': return OddsOption.ML_2;
                    default: console.error('Unknown OddsOption', MarketType[marketType], option); return OddsOption.Unknown;
                }
            case MarketType.FGLG:
                switch (option) {
                    case 'AF': return OddsOption.FGLG_AF;
                    case 'AL': return OddsOption.FGLG_AL;
                    case 'HF': return OddsOption.FGLG_HF;
                    case 'HL': return OddsOption.FGLG_HL;
                    case 'NG': return OddsOption.FGLG_NG;
                    default: console.error('Unknown OddsOption', MarketType[marketType], option); return OddsOption.Unknown;
                }
            case MarketType.DoubleChance:
                switch (option) {
                    case '12': return OddsOption.DC_12;
                    case '1X': return OddsOption.DC_1X;
                    case 'X2': return OddsOption.DC_2X;
                    default: console.error('Unknown OddsOption', MarketType[marketType], option); return OddsOption.Unknown;
                }
            case MarketType.LiveScore:
            case MarketType.FH_LiveScore:
                switch (option.toUpperCase()) {
                    case '1': return OddsOption.LS_1;
                    case '2': return OddsOption.LS_2;
                    case 'X': return OddsOption.LS_X;
                    default: console.error('Unknown OddsOption', MarketType[marketType], option); return OddsOption.Unknown;
                }
            case MarketType.OutRight:
                return OddsOption.OR;
            default:
                console.error('Unknown OddsOption', MarketType[marketType], option); return OddsOption.Unknown;
        }
    }
}

export enum BetTypeGroup {
    Main = 0,
    Soccer_HomeTeamTotalGoal = 123,
    Soccer_AwayTeamTotalGoal = 124,
    Soccer_TotalCorner = 126,
    Soccer_FirstFifteenMinuteFastMarket = 266,
    Soccer_LastFifteenMinuteFastMarket = 269,
    Soccer_FirstGoal = 306,
    Soccer_SecondGoal = 307,
    Soccer_ThirdGoal = 308,
    Soccer_ForthGoal = 309,
    Soccer_FifthGoal = 310,
    Soccer_SixthGoal = 311,
    Soccer_SeventhGoal = 312,
    Soccer_EighthGoal = 313,
    Soccer_NinthGoal = 330,
    Soccer_TenthGoal = 331,
    Soccer_FirstOneMinuteFastMarket = 638,
    Soccer_LastOneMinuteFastMarket = 727,
    Soccer_FirstFiveMinuteFastMarket = 728,
    Soccer_LastFiveMinuteFastMarket = 745,
    Basketball_FirstQuarter = 129,
    Basketball_FirstHalfMoneyLine = 624,
    AmericanFootball_FirstHalfMoneyLine = 636,
    Tennis_GameHandicap = 140,
    Cricket_HighestOpeningPartnership = 150,
    Volleyball_TotalMatchPoints = 174,
    Badminton_TotalMatchPoints = 179,
    Hockey_FirstPeriod = 153,
    Baseball_FirstInningRuns = 337,
    TableTennis_TotalMatchPoints = 281846,
    TableTennis_FirstSetPointHandicap = 281847,
    TableTennis_SecondSetPointHandicap = 281848,
    TableTennis_ThirdSetPointHandicap = 281849,
    TableTennis_FourthSetPointHandicap = 281850,
    TableTennis_FifthSetPointHandicap = 281851,
    TableTennis_SixthSetPointHandicap = 281852,
    TableTennis_SeventhSetPointHandicap = 281853,
    TableTennis_SecondSetHomePlayerTotalPoints = 920368,
    TableTennis_SecondSetAwayTeamTotalPoints = 920377,
    TableTennis_FirstSetHomePlayerTotalPoints = 920505,
    TableTennis_FirstSetAwayPlayerTotalPoints = 920507,
    TableTennis_ThirdSetHomePlayerTotalPoints = 920556,
    TableTennis_FourthSetHomePlayerTotalPoints = 920558,
    TableTennis_FifthSetHomePlayerTotalPoints = 920560,
    TableTennis_SixthSetHomePlayerTotalPoints = 920562,
    TableTennis_SeventhSetHomePlayerTotalPoints = 920564,
    TableTennis_ThirdSetAwayPlayerTotalPoints = 920566,
    TableTennis_FourthSetAwayPlayerTotalPoints = 920569,
    TableTennis_FifthSetAwayPlayerTotalPoints = 920571,
    TableTennis_SixthSetAwayPlayerTotalPoints = 920572,
    TableTennis_SeventhSetAwayPlayerTotalPoints = 920573,
    Futsal_FirstHalf = 626336,
    Soccer_PenaltyTenKick = 1066212,
}

export enum MainBetStatus {
    Unknown = 0,
    Amended = 1,
    Reversed = 2,
    Draw = 3,
    Lose = 4,
    Refunded = 5,
    WaitingRejected = 6,
    Running = 7,
    SpecialVoid = 8,
    Void = 9,
    Waiting = 10,
    Won = 11,
    CashOut = 12,
}

export namespace MainBetStatus {
    export function fromPollux(mainBetStatus: PolluxMainBetStatus): MainBetStatus {
        const mainBetStatusMapping: Record<PolluxMainBetStatus, MainBetStatus> = {
            [PolluxMainBetStatus.Amended]: MainBetStatus.Amended,
            [PolluxMainBetStatus.Reversed]: MainBetStatus.Reversed,
            [PolluxMainBetStatus.Draw]: MainBetStatus.Draw,
            [PolluxMainBetStatus.Lose]: MainBetStatus.Lose,
            [PolluxMainBetStatus.Refunded]: MainBetStatus.Refunded,
            [PolluxMainBetStatus.WaitingRejected]: MainBetStatus.WaitingRejected,
            [PolluxMainBetStatus.Running]: MainBetStatus.Running,
            [PolluxMainBetStatus.SpecialVoid]: MainBetStatus.SpecialVoid,
            [PolluxMainBetStatus.Void]: MainBetStatus.Void,
            [PolluxMainBetStatus.Waiting]: MainBetStatus.Waiting,
            [PolluxMainBetStatus.Won]: MainBetStatus.Won,
            [PolluxMainBetStatus.CashOut]: MainBetStatus.CashOut,
        };
        if (mainBetStatusMapping[mainBetStatus] === undefined) {
            console.error(`transform main bet status from pollux error: ${mainBetStatus}`);
            return MainBetStatus.Unknown;
        }
        return mainBetStatusMapping[mainBetStatus];
    }
}

export enum SubBetStatus {
    Draw = 1,
    Lose = 2,
    Running = 3,
    Void = 4,
    Waiting = 5,
    Won = 6,
    HalfWon = 7,
    HalfLose = 8,
    Suspended = 9,
    WaitingRejected = 10,
    Done = 11,
    Refund = 12,
}

export namespace SubBetStatus {
    export function fromPollux(subBetStatus: PolluxSubBetStatus): SubBetStatus {
        const subBetStatusMapping: Record<PolluxSubBetStatus, SubBetStatus> = {
            [PolluxSubBetStatus.Draw]: SubBetStatus.Draw,
            [PolluxSubBetStatus.Lose]: SubBetStatus.Lose,
            [PolluxSubBetStatus.Running]: SubBetStatus.Running,
            [PolluxSubBetStatus.Void]: SubBetStatus.Void,
            [PolluxSubBetStatus.Waiting]: SubBetStatus.Waiting,
            [PolluxSubBetStatus.Won]: SubBetStatus.Won,
            [PolluxSubBetStatus.HalfWon]: SubBetStatus.HalfWon,
            [PolluxSubBetStatus.HalfLose]: SubBetStatus.HalfLose,
            [PolluxSubBetStatus.Suspended]: SubBetStatus.Suspended,
            [PolluxSubBetStatus.WaitingRejected]: SubBetStatus.WaitingRejected,
            [PolluxSubBetStatus.Done]: SubBetStatus.Done,
            [PolluxSubBetStatus.Refund]: SubBetStatus.Refund,
        };
        return subBetStatusMapping[subBetStatus];
    }
}

// select from AccountDB -> exchange [currency]
export enum SboCurrency {
    SD$ = 'SD$',
    RM = 'RM',
    US$ = 'US$',
    TB = 'TB',
    HK$ = 'HK$',
    EURO = 'EURO',
    PP = 'Pp',
    AUD = 'AUD',
    GBP = 'GBP',
    RMB = 'RMB',
    BDT = 'BDT',
    PESO = 'PESO',
    NIO = 'NIO',
    YEN = 'YEN',
    USD = 'USD',
    LKR = 'LKR',
    PHP = 'php',
    ZAR = 'ZAR',
    KRW = 'KRW',
    CAD = 'CAD',
    NZD = 'NZD',
    NOK = 'NOK',
    SEK = 'SEK',
    CHF = 'CHF',
    BND = 'BND',
    VND = 'VND',
    MMK = 'MMK',
    TMP = 'TMP',
    ZWD = 'ZWD',
    INR = 'INR',
    CNY = 'CNY',
    HKD = 'HKD',
    MYR = 'MYR',
    RR = 'RR',
    USDT = 'USDT',
    BRL = 'BRL',
    KHR = 'KHR',
}

export enum PriceChangeStatus {
    Rise,
    Drop,
    Remain
}

export enum ProductType {
    DefaultPage = 'default_page',
    Sports = 'sports',
    VirtualSports = 'virtual_sports',
    LiveCasino = 'live_casino',
    Games = 'games',
    ESports = 'eSports',
    Keno = 'keno',
    Cockfight = 'cockfight',
    ClassicGames = 'classic_games',
    Racing = 'racing',
    EuroHome = 'euro_home',
    EuroSports = 'euro-sports',
}

export enum ProductCode {
    EuropeHome = 'europe-home',
    EuropeSports = 'europe-sports',
    VirtualSports = 'virtual-sports',
    LiveCasino = 'rc',
    Games = 'gm',
    ESports = 'es',
    Keno = 'keno',
    Cockfight = 'cock-fight',
    ClassicGames = 'cas',
    Racing = 'rt',
}

export enum BrandType {
    Unknown,
    Sbotop,
    Sbobet,
}

export namespace BrandType {
    export function toPollux(brandType: BrandType): PolluxBrandType {
        const brandTypeMapping: Partial<Record<BrandType, PolluxBrandType>> = {
            [BrandType.Sbobet]: PolluxBrandType.SBOBET,
            [BrandType.Sbotop]: PolluxBrandType.SBOTOP,
        };
        const brand = brandTypeMapping[brandType];
        if (brand === undefined) {
            throw new Error(`transform brand type to pollux error: ${brandType}`);
        }
        return brand;
    }

    export function fromPollux(brand: PolluxBrandType): BrandType {
        const brandTypeMapping: Record<PolluxBrandType, BrandType> = {
            [PolluxBrandType.Unknown]: BrandType.Unknown,
            [PolluxBrandType.SBOBET]: BrandType.Sbobet,
            [PolluxBrandType.SBOTOP]: BrandType.Sbotop,
        };
        if (brandTypeMapping[brand] === undefined) {
            console.error(`transform brand type from pollux error: ${brand}`);
            return BrandType.Unknown;
        }
        return brandTypeMapping[brand];
    }
}

export enum OddsDisplayMode {
    Double = 1,
    Single = 2,
}

export namespace OddsDisplayMode {
    export function fromPollux(oddsDisplayMode: PolluxOddsDisplayMode): OddsDisplayMode {
        switch (oddsDisplayMode) {
            case PolluxOddsDisplayMode.Unknown:
            case PolluxOddsDisplayMode.Double:
            case PolluxOddsDisplayMode.Simple:
                return OddsDisplayMode.Double;
            case PolluxOddsDisplayMode.Single:
                return OddsDisplayMode.Single;
            default: console.error(`transform odds display mode from pollux error: ${oddsDisplayMode}`); return OddsDisplayMode.Double;
        }
    }

    export function toPollux(oddsDisplayMode: OddsDisplayMode): PolluxOddsDisplayMode {
        switch (oddsDisplayMode) {
            case OddsDisplayMode.Double:
                return PolluxOddsDisplayMode.Double;
            case OddsDisplayMode.Single:
                return PolluxOddsDisplayMode.Single;
            default: console.error(`transform odds display mode to pollux error: ${oddsDisplayMode}`); return PolluxOddsDisplayMode.Unknown;
        }
    }
}

export enum PriceStyle {
    Unknown = 0,
    Malay = 1,
    HK = 2,
    Indo = 3,
    Euro = 4
}

export namespace PriceStyle {
    export function fromPollux(priceStyle: TiEnumPriceStyle | DisplayOddStyle): PriceStyle {
        switch (priceStyle) {
            case TiEnumPriceStyle.Euro:
            case DisplayOddStyle.Euro:
                return PriceStyle.Euro;
            case TiEnumPriceStyle.HK:
            case DisplayOddStyle.HK:
                return PriceStyle.HK;
            case TiEnumPriceStyle.Indo:
            case DisplayOddStyle.Indo:
                return PriceStyle.Indo;
            case TiEnumPriceStyle.Malay:
            case DisplayOddStyle.Malay:
            case DisplayOddStyle.Myanmar:
                return PriceStyle.Malay;
            case TiEnumPriceStyle.Unknown:
            case DisplayOddStyle.Unknown:
                return PriceStyle.Unknown;
            default: console.error(`transform price style from pollux error: ${priceStyle}`); return PriceStyle.Unknown;
        }
    }
    export function toPollux(priceStyle: PriceStyle): TiEnumPriceStyle {
        switch (priceStyle) {
            case PriceStyle.Euro:
                return TiEnumPriceStyle.Euro;
            case PriceStyle.HK:
                return TiEnumPriceStyle.HK;
            case PriceStyle.Indo:
                return TiEnumPriceStyle.Indo;
            case PriceStyle.Malay:
                return TiEnumPriceStyle.Malay;
            case PriceStyle.Unknown:
                return TiEnumPriceStyle.Unknown;
            default: console.error(`transform price style to pollux error: ${priceStyle}`); return TiEnumPriceStyle.Unknown;
        }
    }

    export function fromOddsApi(oddsStyle: EnumOddsStyle): PriceStyle {
        switch (oddsStyle) {
            case EnumOddsStyle.Malay: return PriceStyle.Malay;
            case EnumOddsStyle.Hk: return PriceStyle.HK;
            case EnumOddsStyle.Indo: return PriceStyle.Indo;
            case EnumOddsStyle.Euro: return PriceStyle.Euro;
            default: return PriceStyle.Unknown;
        }
    }

    export function toOddsApi(priceStyle: PriceStyle): EnumPriceStyle {
        const priceStyleMapping: Partial<Record<PriceStyle, EnumPriceStyle>> = {
            [PriceStyle.Malay]: EnumPriceStyle.Malay,
            [PriceStyle.HK]: EnumPriceStyle.HK,
            [PriceStyle.Indo]: EnumPriceStyle.Indo,
            [PriceStyle.Euro]: EnumPriceStyle.Euro,
        };
        const oddsApiPriceStyle = priceStyleMapping[priceStyle];
        if (oddsApiPriceStyle === undefined) {
            console.error(`transform price style to odds api error: ${priceStyle}`);
            return EnumPriceStyle.Malay;
        }
        return oddsApiPriceStyle;
    }
}

export enum OddsSorting {
    Normal = 1,
    ShowTime = 2,
}

export namespace OddsSorting {
    export function fromPollux(oddsSorting: PolluxOddsSorting): OddsSorting {
        switch (oddsSorting) {
            case PolluxOddsSorting.Unknown:
            case PolluxOddsSorting.Normal:
                return OddsSorting.Normal;
            case PolluxOddsSorting.ShowTime:
                return OddsSorting.ShowTime;
            default: console.error(`transform odds sorting from pollux error: ${oddsSorting}`); return OddsSorting.Normal;
        }
    }

    export function toPollux(oddsSorting: OddsSorting): PolluxOddsSorting {
        switch (oddsSorting) {
            case OddsSorting.Normal:
                return PolluxOddsSorting.Normal;
            case OddsSorting.ShowTime:
                return PolluxOddsSorting.ShowTime;
            default: console.error(`transform odds sorting to pollux error: ${oddsSorting}`); return PolluxOddsSorting.Unknown;
        }
    }
}

export enum MarketShowingType {
    Main = 1,
    All = 2,
}

export enum OddsDaylightType {
    Default = -1,
    Unknown = 0,
    All = 1,
    Within3Hours = 2,
    Within6Hours = 3
}

export enum DisplayTime {
    SystemTime = 0,
    LocalTime = 1,
}

export namespace DisplayTime {
    export function fromPollux(displayTime: PolluxDisplayTime): DisplayTime {
        switch (displayTime) {
            case PolluxDisplayTime.SystemTime:
                return DisplayTime.SystemTime;
            case PolluxDisplayTime.LocalTime:
                return DisplayTime.LocalTime;
            default: console.error(`transform display time from pollux error: ${displayTime}`); return DisplayTime.SystemTime;
        }
    }

    export function toPollux(displayTime: DisplayTime): PolluxDisplayTime {
        switch (displayTime) {
            case DisplayTime.SystemTime:
                return PolluxDisplayTime.SystemTime;
            case DisplayTime.LocalTime:
                return PolluxDisplayTime.LocalTime;
            default: console.error(`transform display time to pollux error: ${displayTime}`); return PolluxDisplayTime.SystemTime;
        }
    }
}

export enum BroadcastChannel {
    BetList = 'BetList',
    SoundChange = 'SoundChange'
}

export enum EventDateType {
    Unknown,
    All,
    Today,
    TodayExpanded,
    Plus1,
    Plus2,
    Plus2Over,
    Plus3,
    Plus4,
    Plus4Over,
    Plus5,
    Plus6,
    Plus6Over,
    EarlyMarket,
}

export namespace EventDateType {
    export function fromOddsApi(oddsApiEventDateFilterType: EnumEventDateFilterType): EventDateType {
        const eventDateTypeMapping: Record<EnumEventDateFilterType, EventDateType> = {
            [EnumEventDateFilterType.All]: EventDateType.All,
            [EnumEventDateFilterType.Today]: EventDateType.Today,
            [EnumEventDateFilterType.TodayExpanded]: EventDateType.TodayExpanded,
            [EnumEventDateFilterType.Plus1]: EventDateType.Plus1,
            [EnumEventDateFilterType.Plus2]: EventDateType.Plus2,
            [EnumEventDateFilterType.Plus2Over]: EventDateType.Plus2Over,
            [EnumEventDateFilterType.Plus3]: EventDateType.Plus3,
            [EnumEventDateFilterType.Plus4]: EventDateType.Plus4,
            [EnumEventDateFilterType.Plus4Over]: EventDateType.Plus4Over,
            [EnumEventDateFilterType.Plus5]: EventDateType.Plus5,
            [EnumEventDateFilterType.Plus6]: EventDateType.Plus6,
            [EnumEventDateFilterType.Plus6Over]: EventDateType.Plus6Over,
            [EnumEventDateFilterType.EarlyMarket]: EventDateType.EarlyMarket,
        };
        return eventDateTypeMapping[oddsApiEventDateFilterType];
    }
}

export enum PresetFilterType {
    All,
    Live,
    NonLive,
    MixParlay,
    OETG,
    CorrectScore,
    HTFT,
    _1X2DC,
    FGLG,
    Outright
}

export namespace PresetFilterType {
    export function fromOddsApi(oddsApiPresetFilterType: EnumPresetFilterType): PresetFilterType {
        const presetFilterTypeMapping: Record<EnumPresetFilterType, PresetFilterType> = {
            [EnumPresetFilterType.All]: PresetFilterType.All,
            [EnumPresetFilterType.Live]: PresetFilterType.Live,
            [EnumPresetFilterType.NonLive]: PresetFilterType.NonLive,
            [EnumPresetFilterType.MixParlay]: PresetFilterType.MixParlay,
            [EnumPresetFilterType.OETG]: PresetFilterType.OETG,
            [EnumPresetFilterType.CorrectScore]: PresetFilterType.CorrectScore,
            [EnumPresetFilterType.HTFT]: PresetFilterType.HTFT,
            [EnumPresetFilterType._1X2DC]: PresetFilterType._1X2DC,
            [EnumPresetFilterType.FGLG]: PresetFilterType.FGLG,
            [EnumPresetFilterType.Outright]: PresetFilterType.Outright,
        };
        return presetFilterTypeMapping[oddsApiPresetFilterType];
    }
}

export enum BetRadarStreamStatus {
    Approved = 'Approved',
    OnAirReady = 'On Air Ready',
    OnAirBroadcast = 'On Air Broadcast',
}

export enum BannerPosition {
    AsiaTop = 0,
    AsiaPopup = 1,
    AsiaSide = 2,
    AsiaMyBetTop = 3,
    EuroTop = 4,
    EuroPopup = 5,
    EuroMyBetTop = 6,
}

export namespace BannerPosition {
    export function toPollux(bannerPosition: BannerPosition): PolluxBannerPosition {
        const bannerPositionMap: Record<BannerPosition, PolluxBannerPosition> = {
            [BannerPosition.AsiaTop]: PolluxBannerPosition.KratosAsiaTop,
            [BannerPosition.AsiaPopup]: PolluxBannerPosition.KratosAsiaPopUp,
            [BannerPosition.AsiaSide]: PolluxBannerPosition.KratosAsiaSide,
            [BannerPosition.AsiaMyBetTop]: PolluxBannerPosition.KratosAsiaMyBetTop,
            [BannerPosition.EuroTop]: PolluxBannerPosition.KratosEuroTop,
            [BannerPosition.EuroPopup]: PolluxBannerPosition.KratosEuroPopUp,
            [BannerPosition.EuroMyBetTop]: PolluxBannerPosition.KratosEuroMyBetTop,
        };

        return bannerPositionMap[bannerPosition] || PolluxBannerPosition.Unknown;
    }
}

export enum BannerAction {
    Unknown = 0,
    NoAction = 1,
    ProductSwitch = 2,
    JoinNow = 3,
    ToSport = 4,
    ToSportMarketPage = 5,
    ToSportLeague = 6,
    SimulateClick = 7,
    RouteTo = 8,
    RedirectTo = 9,
    OpenWindow = 10,
    InJoiOpenGame = 11,
    ToPromotionZone = 12,
    InJoiEventPromotion = 13,
    CasinoInGame = 14,
    CasinoToGameLobby = 15,
    CasinoDealerPage = 16
}

export namespace BannerAction {
    export function fromPollux(action: EnumSportsBannerAction): BannerAction {
        switch (action) {
            case EnumSportsBannerAction.Unknown: return BannerAction.Unknown;
            case EnumSportsBannerAction.NoAction: return BannerAction.NoAction;
            case EnumSportsBannerAction.ProductSwitch: return BannerAction.ProductSwitch;
            case EnumSportsBannerAction.JoinNow: return BannerAction.JoinNow;
            case EnumSportsBannerAction.ToSport: return BannerAction.ToSport;
            case EnumSportsBannerAction.ToSportMarketPage: return BannerAction.ToSportMarketPage;
            case EnumSportsBannerAction.ToSportLeague: return BannerAction.ToSportLeague;
            case EnumSportsBannerAction.SimulateClick: return BannerAction.SimulateClick;
            case EnumSportsBannerAction.RouteTo: return BannerAction.RouteTo;
            case EnumSportsBannerAction.RedirectTo: return BannerAction.RedirectTo;
            case EnumSportsBannerAction.OpenWindow: return BannerAction.OpenWindow;
            case EnumSportsBannerAction.InJoiOpenGame: return BannerAction.InJoiOpenGame;
            case EnumSportsBannerAction.ToPromotionZone: return BannerAction.ToPromotionZone;
            case EnumSportsBannerAction.InJoiEventPromotion: return BannerAction.InJoiEventPromotion;
            case EnumSportsBannerAction.CasinoInGame: return BannerAction.CasinoInGame;
            case EnumSportsBannerAction.CasinoToGameLobby: return BannerAction.CasinoToGameLobby;
            case EnumSportsBannerAction.CasinoDealerPage: return BannerAction.CasinoDealerPage;
            default: console.error(`transform banner action from pollux error: ${action}`); return BannerAction.Unknown;
        }
    }
}

export enum GameFrom {
    SportsAsiaGameBanner = 10202,
    SportsAsiaCarouselBanner = 10206,
    SportsAsiaLeftSideBanner = 10207,
    GamesDesktopBanner = 10302,
    GamesMobileBanner = 20302,
    SyllisSportsToday = 20705,
    SyllisBsi = 20799,
    TeraMobileSportsBanner = 20815,
    TeraMobileLandingBanner = 20816,
    Unknown = -1,
}

export enum CasinoGameFrom {
    KratosTop=320,
    KratosSide=321,
    KratosCover=322,
}

export enum CasinoAutoJoinType {
    None = 0,
    GoodRoadFirstLow = 14
}

export enum SirenSSOLocation {
    PromotionsPage = 1,
    SpecificPromotionPage = 2,
    ReferAFriend = 3,
}

export enum PromotionBannerType {
    MixParlayPromotion = 3,
    VirtualSportsVoucher = 6,
    ResponsibleGambling = 9,
    ChristmasPromotion = 11,
    LiveCasinoPromotion = 13,
    LinePromotion = 14,
    LiveCasinoMobilePromotion = 15,
    YearEndReview = 18,
    GamePromotion = 19,
    SurveyInvitation = 20,
    BvBLuckyDrawPromotion = 26,
    SboClubSportsChallenge = 27,
    InJoiPGPopupBanner = 28,
    QuestionnaireBanner = 29,
    SearchFunctionOnboardingScreen = 500,
    AfricaCupPromotion = 503,
    NbaPromotion = 504,
    EfootballPromotion = 505,
    EuroSportsPromotion = 506,
    ESportsBanner = 600,
    FifaSportsBanner = 601
}

export enum QueryStringSpecialZones {
    EuroSports = 'EuroSports',
    EFootball = 'EFootball'
}

export enum TeamOption{
    Home,
    Away,
}

export enum HandicapType {
    Unknown = 0,
    Home = 1,
    Away = 2,
    None = 3
}

export enum OpenTicketStatus {
    Success = 0,
    InvalidInput = 1,
    EventCompleted = 2,
    EventClosed = 3,
    EventInternal = 4,
    OddsClosed = 5,
    OddsInternal = 6,
    OddsCompleted = 7,
    MaxOddsExceed = 8,
    InvalidPrice = 9,
}

export namespace OpenTicketStatus{
    export const cancelTicketStatus = [
        OpenTicketStatus.EventClosed,
        OpenTicketStatus.EventCompleted,
        OpenTicketStatus.EventInternal,
        OpenTicketStatus.OddsClosed,
        OpenTicketStatus.OddsCompleted,
        OpenTicketStatus.OddsInternal,
    ];

}

export enum TabName {
    Single = 'Single',
    Parlay = 'Parlay',
}

export namespace HandicapType {
    const handicapTypeOddsApiMapping: Record<EnumHandicapType, HandicapType> = {
        [EnumHandicapType.Unknown]: HandicapType.Unknown,
        [EnumHandicapType.Home]: HandicapType.Home,
        [EnumHandicapType.Away]: HandicapType.Away,
        [EnumHandicapType.None]: HandicapType.None,
    };

    export function fromOddsApi(oddsApiHandicapType: EnumHandicapType): HandicapType {
        return handicapTypeOddsApiMapping[oddsApiHandicapType];
    }

    export function toOddsApi(handicapType: HandicapType): EnumHandicapType {
        const oddsApiHandicapType = (Object.keys(handicapTypeOddsApiMapping) as Array<EnumHandicapType>)
            .find(key => handicapTypeOddsApiMapping[key] === handicapType);
        if (oddsApiHandicapType === undefined) {
            throw new Error(`transform handicap type to odds api error: ${handicapType}`);
        }
        return oddsApiHandicapType;
    }

    export function fromPollux(handicapType: PolluxHandicapType): HandicapType {
        switch (handicapType) {
            case PolluxHandicapType.Home: return HandicapType.Home;
            case PolluxHandicapType.Away: return HandicapType.Away;
            case PolluxHandicapType.None: return HandicapType.None;
            default: console.error(`transform handicap type from pollux error: ${handicapType}`); return HandicapType.None;
        }
    }
}

export enum StakeValidStatus {
    Valid,
    StakeLessThanMinBet,
    StakeMoreThanMaxBet,
    StakeMoreThanBalance,
    VoucherLessThanMinBet,
    VoucherMoreThanMaxBet,
}

export enum DisplaySection {
    Unknown = 0,
    TournamentCenter_FeaturedMatches = 1,
    TournamentCenter_Groups = 2,
    TournamentCenter_Knockout = 3,
    TournamentCenter_UpcomingMatches = 4,
    TournamentCenter_Country = 5,
    TournamentCenter_Matches = 6,
}

export enum AsiaBetPageType {
    Unknown = 0,
    DoubleLineLive = 1,
    DoubleLineToday = 2,
    DoubleLineToday3Hours = 3,
    DoubleLineToday6Hours = 4,
    DoubleLineEarlyMarket = 5,
    DoubleLineEarlyMarketPlus1 = 6,
    DoubleLineEarlyMarketPlus2 = 7,
    DoubleLineEarlyMarketPlus3 = 8,
    DoubleLineEarlyMarketPlus4 = 9,
    DoubleLineEarlyMarketPlus5 = 10,
    DoubleLineEarlyMarketPlus6Over = 11,
    SingleLineLive = 12,
    SingleLineToday = 13,
    SingleLineToday3Hours = 14,
    SingleLineToday6Hours = 15,
    SingleLineEarlyMarket = 16,
    SingleLineEarlyMarketPlus1 = 17,
    SingleLineEarlyMarketPlus2 = 18,
    SingleLineEarlyMarketPlus3 = 19,
    SingleLineEarlyMarketPlus4 = 20,
    SingleLineEarlyMarketPlus5 = 21,
    SingleLineEarlyMarketPlus6Over = 22,
    MixParlay = 23,
    Outright = 24,
    DoubleLineMyFavorites = 25,
    SingleLineMyFavorites = 26,
    SportsCup = 27,
    EFootball = 28,
    MultipleSports = 29,
    SportLeague = 30,
    MpRecommendation = 31,
    TournamentCenterFeaturedMatches = 32,
    TournamentCenterUpcomingMatches = 33,
    TournamentCenterMatches = 34,
    TournamentCenterGroups = 35,
    TournamentCenterKnockout = 36,
    SimulationSports = 37,
    DynamicMarket = 38,
    BetBuilderRecommendation = 39,
}

export enum EuroBetPageType {
    Unknown = 0,
    InPlay=1,

    Home_Live = 2,
    Home_Upcoming = 3,

    Sport_Matches_Date=4,
    Sport_Matches_Competitions=5,

    Region_Matches_Date=6,
    Region_Outright=7,

    League_Matches=8,

    MatchDetail=9,

    Multiples=10,
    Multiples_MatchDetail=11,

    Outright=12,
}

export enum PlaceOrderStatus {
    Unknown = 0,
    Success = 1,
    LiveSuccess = 2,
    EventCheckSuccess = 3,
    EventClosed = 4,
    CreditCheckSuccess = 5,
    MemberSuspend = 6,
    MemberClosed = 7,
    HierarchySuspend = 8,
    HierarchyClosed = 9,
    InsufficientCredit = 10,
    BlackListCheckSuccess = 11,
    InBlackList = 12,
    InvalidPrice = 13,
    PriceChange = 14,
    StakeProblem = 15,
    PriceSuspend = 16,
    AccountProblem = 17,
    MaxBetExceed = 18,
    MaxPerMatchExceed = 19,
    PTProblem = 20,
    ExistBetOnSameEvent = 21,
    LessEvent = 22,
    InvalidRefNo = 23,
    IOMWalkinOnly = 24,
    InvalidCookieIdentity = 25,
    SportExcluded = 26,
    HdpPointChange = 27,
    ScoreChanged = 28,
    BettingBudgetExceed = 29,
    MinBetUnMet = 30,
    MPSubBetCountExceed = 31,
    MPMaxPayoutExceed = 32,
    MPMaxAccumulatedStakeForSubEventExceed = 33,
    FailToFulfillBetCountRestrictionForSplitPoint = 34,
    InvalidVoucher = 35,
    InvalidPriceForVoucher = 36,
    InvalidPriceStyle = 37,
    InvalidIp = 38,
    InvalidPriceId = 39,
    PhoneBetting = 40,
    IsNotSingleBet = 41,
    DeductBalanceFail = 42,
    CountryIsBlock = 43,
    InvalidHttpReferer = 44,
    InvalidPriceStyleForVoucher = 45,
    InvalidAccountForVoucher = 46,
    NotValidMixParlayCombination = 47,
    InvalidCurrencyForVietnam = 48,
    PlayerNotLogin = 49,
    LimitExceed = 50,
    MaxWinLoseLimitExceed = 51,
    ThirdPartyTimeout = 52,
    LimitExceedTryLater = 53,
    BetBuilderMaxPayoutExceed = 54,
    BetBuilderMaxAccumulatedStakeExceed = 55,
    LessSelection = 56,
    ExistBetWithSameRefNo = 57,
    IncorrectLiveStatus = 58,
    OrderProcessing = 59,
    RetryOpenTicket = 99,
    GeneralFailure = 255,
}

export namespace PlaceOrderStatus {
    export function fromPollux(status: PolluxPlaceOrderStatus): PlaceOrderStatus {
        const placeOrderStatusMapping: Record<PolluxPlaceOrderStatus, PlaceOrderStatus> = {
            [PolluxPlaceOrderStatus.Unknown]: PlaceOrderStatus.Unknown,
            [PolluxPlaceOrderStatus.Success]: PlaceOrderStatus.Success,
            [PolluxPlaceOrderStatus.LiveSuccess]: PlaceOrderStatus.LiveSuccess,
            [PolluxPlaceOrderStatus.EventCheckSuccess]: PlaceOrderStatus.EventCheckSuccess,
            [PolluxPlaceOrderStatus.EventClosed]: PlaceOrderStatus.EventClosed,
            [PolluxPlaceOrderStatus.CreditCheckSuccess]: PlaceOrderStatus.CreditCheckSuccess,
            [PolluxPlaceOrderStatus.MemberSuspend]: PlaceOrderStatus.MemberSuspend,
            [PolluxPlaceOrderStatus.MemberClosed]: PlaceOrderStatus.MemberClosed,
            [PolluxPlaceOrderStatus.HierarachySuspend]: PlaceOrderStatus.HierarchySuspend,
            [PolluxPlaceOrderStatus.HierarachyClosed]: PlaceOrderStatus.HierarchyClosed,
            [PolluxPlaceOrderStatus.InsufficientCredit]: PlaceOrderStatus.InsufficientCredit,
            [PolluxPlaceOrderStatus.BlackListCheckSuccess]: PlaceOrderStatus.BlackListCheckSuccess,
            [PolluxPlaceOrderStatus.InBlackList]: PlaceOrderStatus.InBlackList,
            [PolluxPlaceOrderStatus.InvalidPrice]: PlaceOrderStatus.InvalidPrice,
            [PolluxPlaceOrderStatus.PriceChange]: PlaceOrderStatus.PriceChange,
            [PolluxPlaceOrderStatus.StakeProblem]: PlaceOrderStatus.StakeProblem,
            [PolluxPlaceOrderStatus.PriceSuspend]: PlaceOrderStatus.PriceSuspend,
            [PolluxPlaceOrderStatus.AccountProblem]: PlaceOrderStatus.AccountProblem,
            [PolluxPlaceOrderStatus.MaxBetExceed]: PlaceOrderStatus.MaxBetExceed,
            [PolluxPlaceOrderStatus.MaxPerMatchExceed]: PlaceOrderStatus.MaxPerMatchExceed,
            [PolluxPlaceOrderStatus.PTProblem]: PlaceOrderStatus.PTProblem,
            [PolluxPlaceOrderStatus.ExistBetOnSameEvent]: PlaceOrderStatus.ExistBetOnSameEvent,
            [PolluxPlaceOrderStatus.LessEvent]: PlaceOrderStatus.LessEvent,
            [PolluxPlaceOrderStatus.InvalidRefNo]: PlaceOrderStatus.InvalidRefNo,
            [PolluxPlaceOrderStatus.IOMWalkinOnly]: PlaceOrderStatus.IOMWalkinOnly,
            [PolluxPlaceOrderStatus.InvalidCookieIdentity]: PlaceOrderStatus.InvalidCookieIdentity,
            [PolluxPlaceOrderStatus.SportExcluded]: PlaceOrderStatus.SportExcluded,
            [PolluxPlaceOrderStatus.HdpPointChange]: PlaceOrderStatus.HdpPointChange,
            [PolluxPlaceOrderStatus.ScoreChanged]: PlaceOrderStatus.ScoreChanged,
            [PolluxPlaceOrderStatus.BettingBudgetExceed]: PlaceOrderStatus.BettingBudgetExceed,
            [PolluxPlaceOrderStatus.MinBetUnMet]: PlaceOrderStatus.MinBetUnMet,
            [PolluxPlaceOrderStatus.MPSubBetCountExceed]: PlaceOrderStatus.MPSubBetCountExceed,
            [PolluxPlaceOrderStatus.MPMaxPayoutExceed]: PlaceOrderStatus.MPMaxPayoutExceed,
            [PolluxPlaceOrderStatus.MPMaxAccumulatedStakeForSubEventExceed]: PlaceOrderStatus.MPMaxAccumulatedStakeForSubEventExceed,
            [PolluxPlaceOrderStatus.FailToFulfillBetCountRestrictionForSplitPoint]: PlaceOrderStatus.FailToFulfillBetCountRestrictionForSplitPoint,
            [PolluxPlaceOrderStatus.InvalidVoucher]: PlaceOrderStatus.InvalidVoucher,
            [PolluxPlaceOrderStatus.InvalidPriceForVoucher]: PlaceOrderStatus.InvalidPriceForVoucher,
            [PolluxPlaceOrderStatus.InvalidPriceStyle]: PlaceOrderStatus.InvalidPriceStyle,
            [PolluxPlaceOrderStatus.InvalidIp]: PlaceOrderStatus.InvalidIp,
            [PolluxPlaceOrderStatus.InvalidPriceId]: PlaceOrderStatus.InvalidPriceId,
            [PolluxPlaceOrderStatus.PhoneBetting]: PlaceOrderStatus.PhoneBetting,
            [PolluxPlaceOrderStatus.IsNotSingleBet]: PlaceOrderStatus.IsNotSingleBet,
            [PolluxPlaceOrderStatus.DeductBalanceFail]: PlaceOrderStatus.DeductBalanceFail,
            [PolluxPlaceOrderStatus.CountryIsBlock]: PlaceOrderStatus.CountryIsBlock,
            [PolluxPlaceOrderStatus.InvalidHttpReferer]: PlaceOrderStatus.InvalidHttpReferer,
            [PolluxPlaceOrderStatus.InvalidPriceStyleForVoucher]: PlaceOrderStatus.InvalidPriceStyleForVoucher,
            [PolluxPlaceOrderStatus.InvalidAccountForVoucher]: PlaceOrderStatus.InvalidAccountForVoucher,
            [PolluxPlaceOrderStatus.NotValidMixParlayCombination]: PlaceOrderStatus.NotValidMixParlayCombination,
            [PolluxPlaceOrderStatus.InvalidCurrencyForVietnam]: PlaceOrderStatus.InvalidCurrencyForVietnam,
            [PolluxPlaceOrderStatus.PlayerNotLogin]: PlaceOrderStatus.PlayerNotLogin,
            [PolluxPlaceOrderStatus.LimitExceed]: PlaceOrderStatus.LimitExceed,
            [PolluxPlaceOrderStatus.MaxWinLoseLimitExceed]: PlaceOrderStatus.MaxWinLoseLimitExceed,
            [PolluxPlaceOrderStatus.ThirdPartyTimeout]: PlaceOrderStatus.ThirdPartyTimeout,
            [PolluxPlaceOrderStatus.LimitExceedTryLater]: PlaceOrderStatus.LimitExceedTryLater,
            [PolluxPlaceOrderStatus.BBMaxPayoutExceed]: PlaceOrderStatus.BetBuilderMaxPayoutExceed,
            [PolluxPlaceOrderStatus.BBMaxAccumulatedStakeExceed]: PlaceOrderStatus.BetBuilderMaxAccumulatedStakeExceed,
            [PolluxPlaceOrderStatus.LessSelection]: PlaceOrderStatus.LessSelection,
            [PolluxPlaceOrderStatus.ExistBetWithSameRefNo]: PlaceOrderStatus.ExistBetWithSameRefNo,
            [PolluxPlaceOrderStatus.IncorrectLiveStatus]: PlaceOrderStatus.IncorrectLiveStatus,
            [PolluxPlaceOrderStatus.OrderProcessing]: PlaceOrderStatus.OrderProcessing,
            [PolluxPlaceOrderStatus.GeneralFailure]: PlaceOrderStatus.GeneralFailure,
            [PolluxPlaceOrderStatus.RetryOpenTicket]: PlaceOrderStatus.RetryOpenTicket,
        };
        if (status as number === 99) {
            return PlaceOrderStatus.RetryOpenTicket;
        }
        if (placeOrderStatusMapping[status] === undefined) {
            console.error(`transform place order status from pollux error: ${status}`);
            return PlaceOrderStatus.Unknown;
        }
        return placeOrderStatusMapping[status];
    }
}

export enum ShowTimeDisplayType {
    None = 0,
    Date = 1,
    DateTime = 2,
    RedLive = 4,
    BlueLive = 8,
}

export namespace ShowTimeDisplayType{
    export function isTvLive(showTimeType: number) {
        return (showTimeType & ShowTimeDisplayType.RedLive) !== 0;
    }

    export function isSboLive(showTimeType: number) {
        return (showTimeType & ShowTimeDisplayType.RedLive) !== 0 || (showTimeType & ShowTimeDisplayType.BlueLive) !== 0;
    }
}

export enum BreakPoint {
    LG = 1024,
    XL = 1360,
    XXL = 1920
}

export enum FGLGResult {
    Unknown = 0,
    Home = 1,
    Away = 2,
    NoGoal = 3,
}

export namespace FGLGResult {
    export function fromPollux(result: EnumResultFGLG): FGLGResult {
        switch (result) {
            case EnumResultFGLG.Unknown:
                return FGLGResult.Unknown;
            case EnumResultFGLG.Home:
                return FGLGResult.Home;
            case EnumResultFGLG.Away:
                return FGLGResult.Away;
            case EnumResultFGLG.NoGoal:
                return FGLGResult.NoGoal;
            default: console.error(`transform FGLG result from pollux error: ${result}`); return FGLGResult.Unknown;
        }
    }
}

export enum ScoringType {
    Unknown,
    Football,
    Golf,
    Badminton,
    BeachSoccer,
    TableTennis,
    BasketBall,
    Tennis,
    MotorSport,
    WinterSport,
    Cricket,
}

export namespace ScoringType {
    export function fromPollux(scoringType: EnumScoringType): ScoringType {
        const scoringTypeMapping: Record<EnumScoringType, ScoringType> = {
            [EnumScoringType.Unknown]: ScoringType.Unknown,
            [EnumScoringType.Football]: ScoringType.Football,
            [EnumScoringType.Golf]: ScoringType.Golf,
            [EnumScoringType.Badminton]: ScoringType.Badminton,
            [EnumScoringType.BeachSoccer]: ScoringType.BeachSoccer,
            [EnumScoringType.TableTennis]: ScoringType.TableTennis,
            [EnumScoringType.BasketBall]: ScoringType.BasketBall,
            [EnumScoringType.Tennis]: ScoringType.Tennis,
            [EnumScoringType.MotorSport]: ScoringType.MotorSport,
            [EnumScoringType.WinterSport]: ScoringType.WinterSport,
            [EnumScoringType.Cricket]: ScoringType.Cricket,
        };
        return scoringTypeMapping[scoringType];
    }
}

export enum ResultType {
    HT = 'HT',
    FT = 'FT',
    TotalPointWin = 'TotalPointWin',
    TotalGamesWin = 'TotalGamesWin',
    TotalSetsWin = 'TotalSetsWin',
}

export enum ColumnGroup {
    FirstHalfScore = 'first_half_score',
    FullTimeScore = 'full_time_score',
    FinalScore = 'final_score',
    TotalPointsWon = 'total_points_won',
    TotalSetsWon = 'total_sets_won',
    TotalGameWon = 'total_game_won',
    Winner = 'winner',
    Round = 'round',
    Result = 'result',
    G5 = 'g5',
    G7 = 'g7',
    P3 = 'p3',
}

export enum MyBetsStatusFilter {
    Running,
    Settled,
}

export enum MyBetsDateFilter {
    Today,
    Tomorrow,
    AllDate,
}

export enum MyBetsColumn {
    Id,
    Time,
    Selection,
    Odds,
    Stake,
    Status,
    WinLoss
}

export enum BroadcastChannelName {
    BetSlip = 'BetSlip',
    CashOut = 'CashOut',
    AcceptAnyCashOutValue = 'AcceptAnyCashOutValue',
    PriceStyle = 'PriceStyle',
    SiteStyle = 'SiteStyle',
}

export enum LeagueSize {
    Big = 'Big',
    Medium = 'Medium',
    Small = 'Small'
}

export namespace LeagueSize {
    const leagueSizeMapping: Record<EnumTournamentSizeType, LeagueSize> = {
        [EnumTournamentSizeType.Big]: LeagueSize.Big,
        [EnumTournamentSizeType.Medium]: LeagueSize.Medium,
        [EnumTournamentSizeType.Small]: LeagueSize.Small,
    };
    export function fromOddsApi(size: EnumTournamentSizeType): LeagueSize {
        return leagueSizeMapping[size];
    }
}

export enum ResultsDateFilter {
    /* Match Result Dates */
    Today,
    Minus1,
    Minus2,
    Minus3,

    /* Outright Result Dates */
    OneWeek,
    TwoWeek,
    OneMonth,
}

export enum ResultsBlockType {
    Time,
    More,
    NextGoal,
}

export enum EventSettleStatus{
    None = 0,
    Settled = 1,
    SettledMultiple = 2,
    Refunded = 4,
    RefundedMultiple = 8,
    SettledCancelled = 16,
    HTSettlement = 32,
    FTSettlement = 64,
    FTRefunded = 128,
    HTSettledMultiple = 256,
    FTSuspendedMatch = 512,
    FHSuspendedMatch = 1024,
    FTCancelled = 2048,
    FHCancelled = 4096,
    FTPostponed = 8192,
    FHPostponed = 16384,
    FTAbandoned = 32768,
    FHAbandoned = 65536,
    FTCompleteEarly = 131072,
    FHCompleteEarly = 262144,
    Pending = 524288,
}

export enum PageType{
    Home,
    Mybets,
    Results,
    LiveStream,
    Preferences,
}

export enum ColumnType{
    Market = 'MARKET',
    Block = 'BLOCK',
}

export enum CashOutResult {
    Success = 1,
    CashOutValueTooHigh = 7,
    SettlementInProgress = 9,
    GeneralError = 15,
    InternalError = 999,
}

export namespace CashOutResult {
    export function fromPollux(cashOutStatus: PolluxCashOutStatus): CashOutResult {
        const cashOutResultMapping: Partial<Record<PolluxCashOutStatus, CashOutResult>> = {
            [PolluxCashOutStatus.Success]: CashOutResult.Success,
            [PolluxCashOutStatus.CashOutValueTooHigh]: CashOutResult.CashOutValueTooHigh,
            [PolluxCashOutStatus.SettlementInProgress]: CashOutResult.SettlementInProgress,
            [PolluxCashOutStatus.InternalError]: CashOutResult.InternalError,
            [PolluxCashOutStatus.RateLimited]: CashOutResult.GeneralError,
        };
        const cashOutResultStatus = cashOutResultMapping[cashOutStatus];
        if (cashOutResultStatus === undefined) {
            console.error(`transform cash out result from pollux error: ${cashOutStatus}`);
            return CashOutResult.InternalError;
        }
        return cashOutResultStatus;
    }
}

export enum CashOutStatus {
    Available,
    UnAvailable,
    Confirm,
    Processing,
    Success,
    PriceError,
    SettlementInProgressError,
    Error,
    GeneralError,
}

export enum BehaviorType {
    Unknown,
    EventsQuery,
    OddsQueryPerEvent,
}

export namespace BehaviorType {
    export function toPollux(type: BehaviorType): PolluxBehaviorType {
        switch (type) {
            case BehaviorType.EventsQuery: return PolluxBehaviorType.EventsQuery;
            case BehaviorType.OddsQueryPerEvent: return PolluxBehaviorType.OddsQueryPerEvent;
            default: console.error(`transform behavior type to pollux error: ${type}`); return PolluxBehaviorType.Unknown;
        }
    }
}

export enum PartialCashOutColumn {
    Id,
    Time,
    Stake,
    WinLoss
}

export enum BetSlipMessagePriority {
    // lowest
    Unknown,
    MaxSelectionsExceeded,
    InvalidStake,
    ScoreChange,
    OddsChange,
    PointChange,
    MaxPayoutExceeded,
    SubscriptionOddsClose,
    Error,
    // highest
}

export enum MatchDetailPreview {
    None = 'none',
    LiveStream = 'live-stream',
    LiveCourt = 'live-court',
}

export enum EnumEuroMarketDropdownPosition {
    None,
    Middle,
    Bottom,
}

export enum NoDataType {
    Events,
    Event,
    Odds,
}

export enum LiveScoreProvider {
    None = -1,
    Sbo = 0,
    Sdt = 1,
    BetRadar = 2,
    Cricket = 3,
    BetConstruct = 4,
    BetGenius = 5,
}

export enum LiveStreamProvider {
    None = 0,
    Twitch = 1,
    MuayThai = 2,
    BetRadar = 3,
    GLive = 4,
    BetConstruct = 5,
    BetGenius = 6,
}

export enum MatchStatus {
    Unknown = -1,
    NotStarted = 0,
    Running = 1,
    Break = 2,
    Pause = 3,
    Ended = 4,
}

export namespace MatchStatus{
    export function fromOddsApi(matchStatus: number): MatchStatus {
        const isValidStatus = Object.values(MatchStatus).includes(matchStatus);
        if (!isValidStatus) {
            console.error(`transform match status from odds api error: ${matchStatus}`);
            return MatchStatus.Unknown;
        }
        return matchStatus;
    }
}

export enum BetRadarLiveScoreStatus {
    Unknown = -1,
    NoError = 0,
    NoParserImplemented = 1,
    FailToParseScore = 2,
    GeneralError = 99,
}

export namespace BetRadarLiveScoreStatus{
    export function fromOddsApi(status: number): BetRadarLiveScoreStatus {
        const isValidStatus = Object.values(BetRadarLiveScoreStatus).includes(status);
        if (!isValidStatus) {
            console.error(`transform bet radar live score status from odds api error: ${status}`);
            return BetRadarLiveScoreStatus.Unknown;
        }
        return status;
    }
}

export enum BetConstructLiveScoreStatus {
    Unknown = -1,
    NoError = 0,
    Abandoned = 1,
    FailToParseScore = 2,
    GeneralError = 99,
}

export namespace BetConstructLiveScoreStatus{
    export function fromOddsApi(status: number): BetConstructLiveScoreStatus {
        const isValidStatus = Object.values(BetConstructLiveScoreStatus).includes(status);
        if (!isValidStatus) {
            console.error(`transform bet construct live score status from odds api error: ${status}`);
            return BetConstructLiveScoreStatus.Unknown;
        }
        return status;
    }
}

export enum BetGeniusLiveScoreStatus {
    Unknown = -1,
    NoError = 0,
    Abandoned = 1,
    FailToParseScore = 2,
    GeneralError = 99,
}

export namespace BetGeniusLiveScoreStatus{
    export function fromOddsApi(status: number): BetGeniusLiveScoreStatus {
        const isValidStatus = Object.values(BetGeniusLiveScoreStatus).includes(status);
        if (!isValidStatus) {
            console.error(`transform bet genius live score status from odds api error: ${status}`);
            return BetGeniusLiveScoreStatus.Unknown;
        }
        return status;
    }
}

export enum BetBuilderTutorialState {
    None = 0,
    Step1 = 1,
    Step2 = 2,
}

export enum HashType {
    MD5,
    SHA256,
}

export enum Popup {
    Banner = 'Banner',
    BetBuilderTutorial = 'BetBuilderTutorial',
}

export enum BetBuilderMarket{
    Unknown = 0,
    Set1x2 = 1,
    SetDoubleChance = 2,
    SetTotalGoalsOverUnder = 3,
    SetTotalGoalsOddEven = 4,
    SetCorrectScore = 5,
    SetExactNumberGoals = 6,
    SetBothTeamsToScore = 7,
    TeamWithMostCorners = 8,
    TotalCornersOU = 9,
    TeamWithMostBookingPoint = 10,
    TotalBookingPointsOU = 11,
    SetTeamTotalGoalsOU = 12,
    SetTeamExactNumberGoals = 13,
    AnytimeGoalscorer = 14,
    PlayerToScoreAHatTrick = 15,
    PlayerToScoreTwoOrMoreGoals = 16,
    FirstGoalscorer = 17,
    LastGoalscorer = 18,
    FirstTeamToScore = 19,
    LastTeamToScore = 20,
    TeamToScoreGoal = 21,
    PlayerToScoreGoal = 22,
    SetHandicap = 47,
    SetTotalCornersHandicap = 49,
    SetTotalCornersOverUnder = 50,
    SetTotalCornersOddEven = 51,
    SetTotalCorners1x2 = 52,
}

export enum BetBuilderStatType{
    Unknown = 0,
    FullTime = 1,
    FirstHalf = 2,
    SecondHalf = 3,
    FullTimeCorners = 4,
    FirstHalfCorners = 5,
    SecondHalfCorners = 6,
    FullTimeBookingPoints = 7,
    FirstHalfBookingPoints = 8,
    SecondHalfBookingPoints = 9,
}

export enum BetBuilderSelectionType{
    Unknown = 0,
    _1 = 1,
    _2 = 2,
    X = 3,
    Odd = 4,
    Even = 5,
    _1X = 6,
    _2X = 7,
    _12 = 8,
    Over = 9,
    Under = 10,
    CorrectScore = 11,
    Goals = 12,
    Yes = 13,
    No = 14,
    PlayerName = 15,
    TeamName = 16,
    Neither = 17,
    TotalGoal = 18,
    Home = 229,
    Away = 230,
}

export enum BetBuilderDisplayType {
    Unknown = 0,
    Handicap = 1,
    OddEven = 2,
    OverUnder = 3,
    CorrectScore = 4,
    _1X2 = 5,
    TotalGoal = 6,
    FH_Handicap = 7,
    FH_1X2 = 8,
    FH_OverUnder = 9,
    HTFT = 10,
    MoneyLine = 11,
    FH_OddEven = 12,
    FGLG = 13,
    FH_CorrectScore = 14,
    DoubleChance = 15,
    LiveScore = 16,
    FH_LiveScore = 17,
    SH_CorrectScore = 19,
    Game = 38,
    OutRight = 39,
    MixParlay = 40,
}

const BetBuilderDisplayTypeMapping: Record<EnumDisplayType, BetBuilderDisplayType> = {
    [EnumDisplayType.Unknown]: BetBuilderDisplayType.Unknown,
    [EnumDisplayType.Handicap]: BetBuilderDisplayType.Handicap,
    [EnumDisplayType.OddEven]: BetBuilderDisplayType.OddEven,
    [EnumDisplayType.OverUnder]: BetBuilderDisplayType.OverUnder,
    [EnumDisplayType.CorrectScore]: BetBuilderDisplayType.CorrectScore,
    [EnumDisplayType._1X2]: BetBuilderDisplayType._1X2,
    [EnumDisplayType.TotalGoal]: BetBuilderDisplayType.TotalGoal,
    [EnumDisplayType.FhHandicap]: BetBuilderDisplayType.FH_Handicap,
    [EnumDisplayType.Fh1X2]: BetBuilderDisplayType.FH_1X2,
    [EnumDisplayType.FhOverUnder]: BetBuilderDisplayType.FH_OverUnder,
    [EnumDisplayType.Htft]: BetBuilderDisplayType.HTFT,
    [EnumDisplayType.MoneyLine]: BetBuilderDisplayType.MoneyLine,
    [EnumDisplayType.FhOddEven]: BetBuilderDisplayType.FH_OddEven,
    [EnumDisplayType.Fglg]: BetBuilderDisplayType.FGLG,
    [EnumDisplayType.FhCorrectScore]: BetBuilderDisplayType.FH_CorrectScore,
    [EnumDisplayType.DoubleChance]: BetBuilderDisplayType.DoubleChance,
    [EnumDisplayType.LiveScore]: BetBuilderDisplayType.LiveScore,
    [EnumDisplayType.FhLiveScore]: BetBuilderDisplayType.FH_LiveScore,
    [EnumDisplayType.ShCorrectScore]: BetBuilderDisplayType.SH_CorrectScore,
    [EnumDisplayType.Game]: BetBuilderDisplayType.Game,
    [EnumDisplayType.OutRight]: BetBuilderDisplayType.OutRight,
    [EnumDisplayType.MixParlay]: BetBuilderDisplayType.MixParlay,
};

const BetBuilderDisplayTypeMappingFromMarketType: Record<MarketType, BetBuilderDisplayType> = {
    [MarketType.Unknown]: BetBuilderDisplayType.Unknown,
    [MarketType.Handicap]: BetBuilderDisplayType.Handicap,
    [MarketType.OddEven]: BetBuilderDisplayType.OddEven,
    [MarketType.OverUnder]: BetBuilderDisplayType.OverUnder,
    [MarketType.CorrectScore]: BetBuilderDisplayType.CorrectScore,
    [MarketType._1X2]: BetBuilderDisplayType._1X2,
    [MarketType.TotalGoal]: BetBuilderDisplayType.TotalGoal,
    [MarketType.FH_Handicap]: BetBuilderDisplayType.FH_Handicap,
    [MarketType.FH_1X2]: BetBuilderDisplayType.FH_1X2,
    [MarketType.FH_OverUnder]: BetBuilderDisplayType.FH_OverUnder,
    [MarketType.HTFT]: BetBuilderDisplayType.HTFT,
    [MarketType.MoneyLine]: BetBuilderDisplayType.MoneyLine,
    [MarketType.FH_OddEven]: BetBuilderDisplayType.FH_OddEven,
    [MarketType.FGLG]: BetBuilderDisplayType.FGLG,
    [MarketType.FH_CorrectScore]: BetBuilderDisplayType.FH_CorrectScore,
    [MarketType.DoubleChance]: BetBuilderDisplayType.DoubleChance,
    [MarketType.LiveScore]: BetBuilderDisplayType.LiveScore,
    [MarketType.FH_LiveScore]: BetBuilderDisplayType.FH_LiveScore,
    [MarketType.SH_CorrectScore]: BetBuilderDisplayType.SH_CorrectScore,
    [MarketType.Game]: BetBuilderDisplayType.Game,
    [MarketType.OutRight]: BetBuilderDisplayType.OutRight,
    [MarketType.MixParlay]: BetBuilderDisplayType.MixParlay,
    [MarketType.BetBuilder]: BetBuilderDisplayType.Unknown,
    [MarketType.Dynamic]: BetBuilderDisplayType.Unknown,
};

export namespace BetBuilderDisplayType {
    export function fromOddsApi(displayType: EnumDisplayType) {
        return BetBuilderDisplayTypeMapping[displayType] ?? BetBuilderDisplayType.Unknown;
    }

    export function fromMarketType(marketType: MarketType) {
        return BetBuilderDisplayTypeMappingFromMarketType[marketType] ?? BetBuilderDisplayType.Unknown;
    }
}

export enum BetBuilderSelectionStatus {
    Unknown = 0,
    Running = 1,
    Suspended = 2,
    Internal = 3,
    Closed = 4,
    Incompatible = 5,
}

export namespace BetBuilderSelectionStatus {
    export function fromOddsApi(status: EnumSelectionStatus) {
        const mapping: Record<EnumSelectionStatus, BetBuilderSelectionStatus> = {
            [EnumSelectionStatus.Unknown]: BetBuilderSelectionStatus.Unknown,
            [EnumSelectionStatus.Running]: BetBuilderSelectionStatus.Running,
            [EnumSelectionStatus.Suspended]: BetBuilderSelectionStatus.Suspended,
            [EnumSelectionStatus.Internal]: BetBuilderSelectionStatus.Internal,
            [EnumSelectionStatus.Closed]: BetBuilderSelectionStatus.Closed,
        };

        return mapping[status] ?? BetBuilderSelectionStatus.Unknown;
    }

    export function fromPollux(status: PolluxSelectionStatus) {
        const mapping: Record<PolluxSelectionStatus, BetBuilderSelectionStatus> = {
            [PolluxSelectionStatus.Unknown]: BetBuilderSelectionStatus.Unknown,
            [PolluxSelectionStatus.Running]: BetBuilderSelectionStatus.Running,
            [PolluxSelectionStatus.Suspended]: BetBuilderSelectionStatus.Suspended,
            [PolluxSelectionStatus.Internal]: BetBuilderSelectionStatus.Internal,
            [PolluxSelectionStatus.Closed]: BetBuilderSelectionStatus.Closed,
            [PolluxSelectionStatus.Incompatible]: BetBuilderSelectionStatus.Incompatible,
        };
        return mapping[status] ?? BetBuilderSelectionStatus.Unknown;
    }
}

export enum BetBuilderTicketStatus {
    Unknown = 0,
    Available = 1,
    Unavailable = 2,
    InsufficientLegs = 3,
    MaxLegCountExceeded = 4,
    RedundantSelection = 5,
    IncompatibleSelection = 6,
}

export namespace BetBuilderTicketStatus {
    export function fromPollux(status: CompositeMarketStatus) {
        const mapping: Record<CompositeMarketStatus, BetBuilderTicketStatus> = {
            [CompositeMarketStatus.Unknown]: BetBuilderTicketStatus.Unknown,
            [CompositeMarketStatus.Available]: BetBuilderTicketStatus.Available,
            [CompositeMarketStatus.Unavailable]: BetBuilderTicketStatus.Unavailable,
            [CompositeMarketStatus.InsufficientLegs]: BetBuilderTicketStatus.InsufficientLegs,
            [CompositeMarketStatus.MaxLegCountExceeded]: BetBuilderTicketStatus.MaxLegCountExceeded,
            [CompositeMarketStatus.RedundantSelection]: BetBuilderTicketStatus.RedundantSelection,
            [CompositeMarketStatus.IncompatibleSelection]: BetBuilderTicketStatus.IncompatibleSelection,
        };

        return mapping[status] ?? BetBuilderTicketStatus.Unknown;
    }
}

export enum SelectionOutcome {
    NoOutcome = 0,
    WON = 1,
    LOSE = 2,
    REFUND = 3,
    DRAW = 4,
    HALF_WIN = 6,
    HALF_LOSE = 7,
    VOID_SUSPENDED_MATCH = 9,
}

export namespace SelectionOutcome {
    export function fromPollux(outcome: PolluxSelectionOutcome) {
        const mapping: Record<PolluxSelectionOutcome, SelectionOutcome> = {
            [PolluxSelectionOutcome.NoOutcome]: SelectionOutcome.NoOutcome,
            [PolluxSelectionOutcome.WON]: SelectionOutcome.WON,
            [PolluxSelectionOutcome.LOSE]: SelectionOutcome.LOSE,
            [PolluxSelectionOutcome.REFUND]: SelectionOutcome.REFUND,
            [PolluxSelectionOutcome.DRAW]: SelectionOutcome.DRAW,
            [PolluxSelectionOutcome.HALF_WIN]: SelectionOutcome.HALF_WIN,
            [PolluxSelectionOutcome.HALF_LOSE]: SelectionOutcome.HALF_LOSE,
            [PolluxSelectionOutcome.VOID_SUSPENDED_MATCH]: SelectionOutcome.VOID_SUSPENDED_MATCH,
        };

        return mapping[outcome] ?? SelectionOutcome.NoOutcome;
    }
}

export enum StatementDetailStatus {
    Unknown = 0,
    Running = 1,
    Waiting = 2,
    Won = 3,
    Lose = 4,
    Draw = 5,
    Rejected = 6,
    Void = 7,
    Refunded = 8,
    SpecialVoid = 9,
    HalfWon = 10,
    HalfLose = 11,
    SuspendVoid = 12,
    DangerousMpVoid = 13,
    CashOut = 16,
    CashOutBet = 32,
}

export namespace StatementDetailStatus {
    export function fromPollux(status: TiEnumStatementDetailStatus): StatementDetailStatus {
        const statementDetailStatusMapping: Record<TiEnumStatementDetailStatus, StatementDetailStatus> = {
            [TiEnumStatementDetailStatus.Unknown]: StatementDetailStatus.Unknown,
            [TiEnumStatementDetailStatus.Running]: StatementDetailStatus.Running,
            [TiEnumStatementDetailStatus.Waiting]: StatementDetailStatus.Waiting,
            [TiEnumStatementDetailStatus.Won]: StatementDetailStatus.Won,
            [TiEnumStatementDetailStatus.Lose]: StatementDetailStatus.Lose,
            [TiEnumStatementDetailStatus.Draw]: StatementDetailStatus.Draw,
            [TiEnumStatementDetailStatus.Rejected]: StatementDetailStatus.Rejected,
            [TiEnumStatementDetailStatus.Void]: StatementDetailStatus.Void,
            [TiEnumStatementDetailStatus.Refunded]: StatementDetailStatus.Refunded,
            [TiEnumStatementDetailStatus.Special_Void]: StatementDetailStatus.SpecialVoid,
            [TiEnumStatementDetailStatus.HalfWon]: StatementDetailStatus.HalfWon,
            [TiEnumStatementDetailStatus.HalfLose]: StatementDetailStatus.HalfLose,
            [TiEnumStatementDetailStatus.SuspendVoid]: StatementDetailStatus.SuspendVoid,
            [TiEnumStatementDetailStatus.Dangerous_Mp_Void]: StatementDetailStatus.DangerousMpVoid,
            [TiEnumStatementDetailStatus.CashOut]: StatementDetailStatus.CashOut,
            [TiEnumStatementDetailStatus.CashOutBet]: StatementDetailStatus.CashOutBet,
        };
        if (statementDetailStatusMapping[status] === undefined) {
            console.error(`transform statement detail status from pollux error: ${status}`);
            return StatementDetailStatus.Unknown;
        }
        return statementDetailStatusMapping[status];
    }
}

export enum ExchangeStatus {
    Unknown,
    Success,
    Error,
    ThirdPartyError
}

export namespace ExchangeStatus {
    export function fromPollux(status: PolluxExchangeStatus): ExchangeStatus {
        const exchangeStatusMapping: Record<PolluxExchangeStatus, ExchangeStatus> = {
            [PolluxExchangeStatus.Unknown]: ExchangeStatus.Unknown,
            [PolluxExchangeStatus.Success]: ExchangeStatus.Success,
            [PolluxExchangeStatus.Error]: ExchangeStatus.Error,
            [PolluxExchangeStatus.ThirdPartyError]: ExchangeStatus.ThirdPartyError,
        };
        if (exchangeStatusMapping[status] === undefined) {
            console.error(`transform exchange status from pollux error: ${status}`);
            return ExchangeStatus.Unknown;
        }
        return exchangeStatusMapping[status];
    }
}

export enum ExchangeAction {
    TransferIn = 'transferIn',
    TransferOut = 'transferOut',
}

export enum ExchangeTransferState {
    BeforeTransfer,
    TransferInSuccess,
    TransferInThirdPartyError,
    TransferInError,
    TransferOutSuccess,
    TransferOutThirdPartyError,
    TransferOutError,
}

export enum ExchangeTransferValidStatus {
    Valid,
    AccountProblem,
    ExceedBettingBudget,
    InsufficientInAccount,
    InsufficientInWallet,
}

export enum OddApiStatus {
    NO_TOKEN = 'NO_TOKEN',
    LOADED = 'LOADED',
    LOADING = 'LOADING',
    ERRORED = 'ERRORED',
}

export enum FantasySelectionMyBetsTab {
    All = 'all',
    Running = 'running',
    Settled = 'settled',
}

export enum PoolMaxEntries {
    Unlimited = 'unlimited',
    Two = 'h2h',
    Three = '3players',
    Six = '6players',
}

export enum FantasySelectionBetStatus {
    Running,
    Won,
    Lose,
    Refund,
    Amended,
    Reversed,
}

export namespace FantasySelectionBetStatus {
    export function fromPollux(status: PolluxFantasySelectionBetStatus): FantasySelectionBetStatus {
        const statusMapping: Record<PolluxFantasySelectionBetStatus, FantasySelectionBetStatus> = {
            [PolluxFantasySelectionBetStatus.Running]: FantasySelectionBetStatus.Running,
            [PolluxFantasySelectionBetStatus.Won]: FantasySelectionBetStatus.Won,
            [PolluxFantasySelectionBetStatus.Lost]: FantasySelectionBetStatus.Lose,
            [PolluxFantasySelectionBetStatus.Refunded]: FantasySelectionBetStatus.Refund,
            [PolluxFantasySelectionBetStatus.Amended]: FantasySelectionBetStatus.Amended,
            [PolluxFantasySelectionBetStatus.Reversed]: FantasySelectionBetStatus.Reversed,
        };
        return statusMapping[status];
    }
}

export enum FantasySelectionOrderStatus {
    Unknown = 0,
    Success = 1,
    ContestClosed = 10,
    PoolFull = 11,
    MemberSuspend = 20,
    AccountProblem = 22,
    TestAccountBettingDisabled = 23,
    HasDepositBonus = 24,
    BettingBudgetExceeded = 25,
    UserNotTestAccount = 26,
    InsufficientCredit = 30,
    StakeOverThanMaxBet = 31,
    StakeLowerThanMinBet = 32,
    GeneralFailure = 255,
}

export namespace FantasySelectionOrderStatus {
    export function fromPollux(status: PolluxFantasySelectionOrderStatus): FantasySelectionOrderStatus {
        const statusMapping: Record<PolluxFantasySelectionOrderStatus, FantasySelectionOrderStatus> = {
            [PolluxFantasySelectionOrderStatus.Unknown]: FantasySelectionOrderStatus.Unknown,
            [PolluxFantasySelectionOrderStatus.Success]: FantasySelectionOrderStatus.Success,
            [PolluxFantasySelectionOrderStatus.ContestClosed]: FantasySelectionOrderStatus.ContestClosed,
            [PolluxFantasySelectionOrderStatus.PoolFull]: FantasySelectionOrderStatus.PoolFull,
            [PolluxFantasySelectionOrderStatus.MemberSuspend]: FantasySelectionOrderStatus.MemberSuspend,
            [PolluxFantasySelectionOrderStatus.MemberClosed]: FantasySelectionOrderStatus.GeneralFailure,
            [PolluxFantasySelectionOrderStatus.AccountProblem]: FantasySelectionOrderStatus.AccountProblem,
            [PolluxFantasySelectionOrderStatus.TestAccountBettingDisabled]: FantasySelectionOrderStatus.TestAccountBettingDisabled,
            [PolluxFantasySelectionOrderStatus.HasDepositBonus]: FantasySelectionOrderStatus.HasDepositBonus,
            [PolluxFantasySelectionOrderStatus.BettingBudgetExceeded]: FantasySelectionOrderStatus.BettingBudgetExceeded,
            [PolluxFantasySelectionOrderStatus.UserNotTestAccount]: FantasySelectionOrderStatus.UserNotTestAccount,
            [PolluxFantasySelectionOrderStatus.InsufficientCredit]: FantasySelectionOrderStatus.InsufficientCredit,
            [PolluxFantasySelectionOrderStatus.StakeOverThanMaxBet]: FantasySelectionOrderStatus.StakeOverThanMaxBet,
            [PolluxFantasySelectionOrderStatus.StakeLowerThanMinBet]: FantasySelectionOrderStatus.StakeLowerThanMinBet,
            [PolluxFantasySelectionOrderStatus.GeneralFailure]: FantasySelectionOrderStatus.GeneralFailure,
        };
        return statusMapping[status] ?? FantasySelectionOrderStatus.GeneralFailure;
    }
}

export enum ContestStatus {
    Unknown,
    Running,
    Closed,
    PendingResult,
    Completed,
}

export namespace ContestStatus {
    export function fromPollux(status: PolluxContestStatus): ContestStatus {
        const statusMapping: Record<PolluxContestStatus, ContestStatus> = {
            [PolluxContestStatus.Unknown]: ContestStatus.Unknown,
            [PolluxContestStatus.Running]: ContestStatus.Running,
            [PolluxContestStatus.Closed]: ContestStatus.Closed,
            [PolluxContestStatus.PendingResult]: ContestStatus.PendingResult,
            [PolluxContestStatus.Completed]: ContestStatus.Completed,
        };
        return statusMapping[status] ?? ContestStatus.Unknown;
    }
}

export enum RecommendType {
    Unknown = 0,
    BetCount = 1,
    Turnover = 2,
}

export namespace RecommendType {
    export function toRogue(recommendType: RecommendType): RogueRecommendType {
        const recommendTypeMapping: Record<RecommendType, RogueRecommendType> = {
            [RecommendType.Unknown]: 0,
            [RecommendType.BetCount]: 1,
            [RecommendType.Turnover]: 2,
        };
        return recommendTypeMapping[recommendType];
    }
}

export enum TokenVersion {
    SB = 'SB', // Soccer Big
    SM = 'SM', // Soccer Medium
    SS = 'SS', // Soccer Small
    OB = 'OB', // Others Big
    OM = 'OM', // Others Medium
    OS = 'OS', // Others Small
}

export namespace TokenVersion {
    export function toOddsApi(version: TokenVersion): EnumTokenVersion {
        const tokenVersionMapping: Record<TokenVersion, EnumTokenVersion> = {
            [TokenVersion.SB]: EnumTokenVersion.SB,
            [TokenVersion.SM]: EnumTokenVersion.SM,
            [TokenVersion.SS]: EnumTokenVersion.SS,
            [TokenVersion.OB]: EnumTokenVersion.OB,
            [TokenVersion.OM]: EnumTokenVersion.OM,
            [TokenVersion.OS]: EnumTokenVersion.OS,
        };
        return tokenVersionMapping[version];
    }

    export function toOddsApiMarked(version: TokenVersion): EnumMarkedTokenVersion {
        const markedTokenVersionMapping: Record<TokenVersion, EnumMarkedTokenVersion> = {
            [TokenVersion.SB]: EnumMarkedTokenVersion.SB,
            [TokenVersion.SM]: EnumMarkedTokenVersion.SM,
            [TokenVersion.SS]: EnumMarkedTokenVersion.SS,
            [TokenVersion.OB]: EnumMarkedTokenVersion.OB,
            [TokenVersion.OM]: EnumMarkedTokenVersion.OM,
            [TokenVersion.OS]: EnumMarkedTokenVersion.OS,
        };
        return markedTokenVersionMapping[version];
    }
}

export enum TimezoneOffset {
    Server = -4,
    Singapore = 8,
}

export enum TournamentStandingTab {
    Groups = 'groups',
    Knockouts = 'knockouts',
}

export enum GroupTableColumn {
    Played = 'played',
    Won = 'won',
    Drawn = 'drawn',
    Lost = 'lost',
    GoalDifference = 'goalDifference',
    Points = 'points',
    Winner = 'winner',
}

export enum EventStatus {
    Unknown = 0,
    Running = 1,
    Internal = 2,
    Closed = 3,
    Completed = 4,
}

export namespace EventStatus {
    export function fromOddsApi(eventStatus: TiEnumEventStatus): EventStatus {
        const eventStatusMapping: Record<TiEnumEventStatus, EventStatus> = {
            [TiEnumEventStatus.Unknown]: EventStatus.Unknown,
            [TiEnumEventStatus.Running]: EventStatus.Running,
            [TiEnumEventStatus.Internal]: EventStatus.Internal,
            [TiEnumEventStatus.Closed]: EventStatus.Closed,
            [TiEnumEventStatus.Completed]: EventStatus.Completed,
        };

        return eventStatusMapping[eventStatus] ?? EventStatus.Unknown;
    }
}

export enum TournamentStage {
    Unknown = 0,
    Final = 1,
    ThirdPlace = 2,
    SemiFinals = 3,
    QuarterFinals = 4,
    RoundOf16 = 5,
    RoundOf32 = 6,
    Group = 7,
}

export namespace TournamentStage {
    export function fromOddsApi(oddsApiTournamentStage: EnumTournamentStage): TournamentStage {
        const tournamentStageMapping: Record<EnumTournamentStage, TournamentStage> = {
            [EnumTournamentStage.Unknown]: TournamentStage.Unknown,
            [EnumTournamentStage.Final]: TournamentStage.Final,
            [EnumTournamentStage.ThirdPlace]: TournamentStage.ThirdPlace,
            [EnumTournamentStage.SemiFinals]: TournamentStage.SemiFinals,
            [EnumTournamentStage.QuarterFinals]: TournamentStage.QuarterFinals,
            [EnumTournamentStage.RoundOf16]: TournamentStage.RoundOf16,
            [EnumTournamentStage.RoundOf32]: TournamentStage.RoundOf32,
        };
        return tournamentStageMapping[oddsApiTournamentStage] ?? TournamentStage.Unknown;
    }
}

export enum InternalPromotionStage {
    Group = 1,
    Knockout = 2,
    Ultimate = 3,
}

export namespace InternalPromotionStage {
    export function fromPollux(stage: PolluxInternalPromotionStage): InternalPromotionStage {
        switch (stage) {
            case PolluxInternalPromotionStage.Group:
                return InternalPromotionStage.Group;
            case PolluxInternalPromotionStage.Knockout:
                return InternalPromotionStage.Knockout;
            case PolluxInternalPromotionStage.Ultimate:
                return InternalPromotionStage.Ultimate;
            default:
                console.error(`transform InternalPromotionStage from pollux error: ${stage}`);
                return InternalPromotionStage.Group;
        }
    }

    export function toPollux(stage: InternalPromotionStage): PolluxInternalPromotionStage {
        switch (stage) {
            case InternalPromotionStage.Group:
                return PolluxInternalPromotionStage.Group;
            case InternalPromotionStage.Knockout:
                return PolluxInternalPromotionStage.Knockout;
            case InternalPromotionStage.Ultimate:
                return PolluxInternalPromotionStage.Ultimate;
            default:
                console.error(`transform InternalPromotionStage to pollux error: ${stage}`);
                return PolluxInternalPromotionStage.Group;
        }
    }
}

export enum BetBuilderMultipleGroup {
    TotalCorner,
}
